webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Report_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Report_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Report_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Model_history_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Model_history_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Model_history_vue__);







var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Model_history_vue___default.a,
    name: 'dashboard',
    alias: '',
    meta: { description: 'Dashboard' }
  }, {
    path: 'Report',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Report_vue___default.a,
    name: 'VisnetworkView',
    alias: '',
    meta: { description: 'VisnetworkView' }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(158);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_App_vue__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_5__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_5__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_5__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */],
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.auth && to.router.app.$store.state.token === 'null') {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: '/login' }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], router);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__components_App_vue___default.a);
  }
});

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = localUserString;

  if (localUser && __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handsontable = __webpack_require__(16);

var _handsontable2 = _interopRequireDefault(_handsontable);

var _settingsMapper = __webpack_require__(147);

var _settingsMapper2 = _interopRequireDefault(_settingsMapper);

var _helpers = __webpack_require__(292);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'HotTable',
  props: _helpers.propFactory.call(undefined),
  watch: _helpers.propWatchFactory.call(undefined, _helpers.updateHotSettings, _helpers.updateBulkHotSettings),
  mounted: function mounted() {
    return _helpers.hotInit.call(this);
  },
  beforeDestroy: function beforeDestroy() {
    return _helpers.hotDestroy.call(this);
  }
}; //
//
//
//

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('email', null);
        window.localStorage.setItem('username', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__Sidebar___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].hideLogoOnMobile
      },
      error: ''
    };
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('user') === 'null' || window.localStorage.length === 0) {
      this.$router.push('/login');
    }
    this.responsiveRestrictions();
    window.addEventListener('resize', this.responsiveRestrictions);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: localStorage.getItem('username'),
        avatar: '/static/img/stock/user.png',
        email: localStorage.getItem('email'),
        randomCard: ''
      };
    }
  }),
  methods: {
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    logout: function logout() {
      this.$parent.logout();
    },
    responsiveRestrictions: function responsiveRestrictions() {
      if (window.innerWidth < 1380) {
        var modelCreatedModal = {
          title: 'Screen resolution is not compatible, please try with higher resolutions',
          message: '',
          type: 'success',
          customCloseBtnClass: 'btn btn-primary'
        };
        this.$refs.confirmbox.openSimplert(modelCreatedModal);
      }
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: { Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a },
  data: function data(router) {
    return {
      loadingtext: '',
      section: 'Login',
      loading: '',
      username: '',
      response: '',
      XpiKey_prod: 'SFZMWjLFzd6MxLmgHw5Kk4MFMENTRQOa34AcnNVg',
      ApiURL_prod: 'https://7uzb1bv3pc.execute-api.eu-west-1.amazonaws.com/prod',
      XpiKey_dev: '9rMnjaACpH1FEx7l1X7uU8XP1MU6wCMyIcqpdtDf',
      ApiURL_dev: 'https://bjgimmvuwh.execute-api.eu-west-1.amazonaws.com/dev',
      XpiKey_qa: 'NRG4MOLYjH402FpP4ryQVLhJgXqv4NL8NT4TFqm8',
      ApiURL_qa: 'https://53hh1vlaih.execute-api.eu-west-1.amazonaws.com/qa',
      defaultjodid: 'ee163972-5a95-4e70-8f6b-33131534ab1e'
    };
  },

  methods: {
    displaypopuperr: function displaypopuperr() {
      var err = {
        title: 'Error',
        message: 'Your Login credentials are incorrect',
        type: 'error',
        customClass: 'error'
      };
      this.$refs.simplert.openSimplert(err);
    },
    getApptype: function getApptype() {
      function getSubdomain(hostname) {
        var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$');
        var urlParts = regexParse.exec(hostname);
        return hostname.replace(urlParts[0], '').slice(0, -1);
      }
      getSubdomain(window.location.hostname);
      var locationbr = getSubdomain(window.location.hostname);
      var jobid = 'job-id=' + this.defaultjodid;
      window.localStorage.setItem('JobId', jobid);
      window.localStorage.setItem('XpiKey', this.XpiKey_dev);
      window.localStorage.setItem('ApiURL', this.ApiURL_dev);
      if (locationbr === 'velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_prod);
        window.localStorage.setItem('ApiURL', this.ApiURL_prod);
      } else if (locationbr === 'dev-velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_dev);
        window.localStorage.setItem('ApiURL', this.ApiURL_dev);
      } else if (locationbr === 'beta-velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_qa);
        window.localStorage.setItem('ApiURL', this.ApiURL_qa);
      } else if (locationbr === 'new-qa') {
        window.localStorage.setItem('XpiKey', this.XpiKey_dev);
        window.localStorage.setItem('ApiURL', this.ApiURL_dev);
      }
    },
    checkCreds: function checkCreds() {
      var self = this;

      self.getApptype();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.spinner').hide();
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VelocityUserAuthentication',
        data: { 'user-id': self.username },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          self.loadingtext = 'processing...';
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.spinner').show();
        },
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.spinner').hide();
        },
        success: function success(data) {
          console.log(data['user-data']);
          data = data['user-data'];

          console.log(data);
          if (!data) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.spinner').hide();
            self.displaypopuperr();
          }
          data = JSON.parse(data);
          if (data) {
            self.$parent.$store.commit('SET_USER', self.username);

            if (window.localStorage) {
              window.localStorage.setItem('user', self.username);
              window.localStorage.setItem('username', data.name);
              window.localStorage.setItem('email', data.email);
            }
            self.$router.push('/');
          } else {
            window.localStorage.setItem('user', null);
            window.localStorage.setItem('email', null);
            window.localStorage.setItem('username', null);
            window.localStorage.setItem('token', null);
            window.localStorage.setItem('XpiKey', null);
            window.localStorage.setItem('ApiURL', null);
            self.displaypopuperr();
            return;
          }
          return data;
        },
        error: function error(data, _error) {
          console.log(data);
          console.log(_error);
          __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.spinner').hide();
          self.displaypopuperr();
        }
      });
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarName',
  methods: {
    toggleMenu: function toggleMenu(event) {
      var active = document.querySelector('li.pageLink.active');

      if (active) {
        active.classList.remove('active');
      }

      event.toElement.parentElement.className = 'pageLink active';
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model_one_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Model_one_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Model_one_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_two_vue__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_two_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Model_two_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Model_three_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Model_three_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Model_three_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Model_four_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Model_four_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Model_four_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_simplert__);









var $ = __WEBPACK_IMPORTED_MODULE_5_jquery___default.a;
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'step1': __WEBPACK_IMPORTED_MODULE_1__Model_one_vue___default.a,
    'step2': __WEBPACK_IMPORTED_MODULE_2__Model_two_vue___default.a,
    'step3': __WEBPACK_IMPORTED_MODULE_3__Model_three_vue___default.a,
    'step4': __WEBPACK_IMPORTED_MODULE_4__Model_four_vue___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default.a
  },
  props: ['modelType'],
  data: function data() {
    return {
      Input: [],
      ActiveComponent: 'step1',
      step: 1,
      steps: 4,
      ModalHeight: window.outerHeight - 180,
      CreatedModel: {
        'market': '',
        'name': '',
        base_sales_flag: false,
        'country': '',
        'KPI': '',
        'user_id': window.localStorage.getItem('user'),
        'nests': ['Sales'],
        'initial_annual_spend': {
          'is-table': true,
          'table-data': {
            'Annual spend': [],
            'Channels': []
          }
        },
        'total_weekly_sales': {
          'is-table': true,
          'table-data': {
            'week_no': [],
            'weekly_base_sales': []
          }
        },
        'ccs': {
          'is-table': true,
          'table-data': {
            'Channels': [],
            'Direct Reach': []
          }
        },
        'size_propensity': {
          'is-table': true,
          'table-data': {
            'Size': ['Size'],
            'Direct Reach': []
          }
        }
      },
      Validate: {
        'step1': true,
        'step2': true,
        'step3': true,
        'step4': true
      },
      ccsRemove: true,
      ViewModel: ''
    };
  },
  created: function created() {
    var self = this;
    if (this.modelType === 'create') {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner').show();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner .loadingtext').text('fetching available countries and categories...');
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner .loadingtext').text('almost done!');
      }, 2000);
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VelocityGetLookupTable',
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          self.loadingtext = 'processing...';
          $('.spinner').show();
        },
        complete: function complete() {
          $('.spinner').hide();
        },
        success: function success(data) {
          self.Input = JSON.parse(data['lookup-data']);
          return data;
        },
        error: function error(data, _error) {
          console.log(_error);
          $('.spinner').hide();
          self.errorPopup();
        }
      });
    } else if (this.modelType === 'view') {
      this.steps = 3;

      this.getreadonlyform();
    }
  },

  methods: {
    errorPopup: function errorPopup() {
      var err = {
        title: 'Data Error',
        message: ' ',
        type: 'error',
        customClass: 'error'
      };
      this.$refs.simplert.openSimplert(err);
    },
    getreadonlyform: function getreadonlyform() {
      var jobId = window.localStorage.getItem('JobId');
      jobId = jobId.replace('job-id=', '');
      var ddta = { 'job-id': jobId, 'user-id': window.localStorage.getItem('user') };

      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/getorupdatemodel',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ddta),
        async: true,
        contentType: 'application/json',
        headers: { 'x-api-key': window.localStorage.getItem('XpiKey') },
        beforeSend: function beforeSend() {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner').show();
          self.loadingtext = 'fetching your models...';
          setTimeout(function () {
            self.loadingtext = 'almost done!';
          }, 2000);
        },
        complete: function complete() {
          __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner').hide();
        },
        success: function success(data) {
          self.ViewModel = data['output'];
        },
        error: function error(data, _error2) {
          console.log(data);
          console.log(_error2);
          self.errorPopup();
        }
      });
    },
    getObject: function getObject() {
      console.log(this.CreatedModel);
    },
    nextStep: function nextStep() {
      if (this.modelType !== 'view') {
        if (this.validateFirstStep() && this.step === 1) {
          this.ActiveComponent = 'step' + ++this.step;
        } else if (this.validateSecondStep() && this.step === 2) {
          this.ActiveComponent = 'step' + ++this.step;
        } else if (this.validateThirdStep() && this.step === 3) {
          this.ActiveComponent = 'step' + ++this.step;
        } else {
          return false;
        }
      } else {
        this.ActiveComponent = 'step' + ++this.step;
      }
    },
    backStep: function backStep() {
      this.ActiveComponent = 'step' + --this.step;
    },
    createModel: function createModel() {
      var _this = this;

      if (this.validateFourthStep() && this.step === 4) {
        if (this.ccsRemove) {
          delete this.CreatedModel.ccs;
          delete this.CreatedModel.size_propensity;
        }
        __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
          type: 'POST',
          url: window.localStorage.getItem('ApiURL') + '/VelocityCreateModel',
          data: { 'data': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.CreatedModel) },
          async: true,
          contentType: 'application/json',
          headers: {
            'x-api-key': window.localStorage.getItem('XpiKey')
          },
          beforeSend: function beforeSend() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner').show();
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner .loadingtext').text('setting up model framework...');
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner .loadingtext').text('calculating ecosystem...');
            }, 2000);
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner .loadingtext').text('almost done!');
            }, 4000);
          },
          complete: function complete() {
            __WEBPACK_IMPORTED_MODULE_5_jquery___default()('.spinner').hide();
          },
          success: function success(data) {
            data = data['output'];
            data = JSON.parse(data);
            var jobid = 'job-id=' + data.job_id;
            window.localStorage.setItem('JobId', jobid);
            _this.$emit('close');
            _this.$emit('openModal');
          },
          error: function error(data, _error3) {
            console.log(_error3);
          }
        });
      }
    },
    stepsValidations: function stepsValidations(step) {
      if (step === 1) {
        this.validateFirstStep();
      } else if (step === 2) {
        this.validateSecondStep();
      } else if (step === 3) {
        this.validateThirdStep();
      } else if (step === 4) {
        this.validateFourthStep();
      }
    },
    validateFirstStep: function validateFirstStep() {
      if (this.CreatedModel.name !== '' && this.CreatedModel.country !== '' && this.CreatedModel.market !== '' && this.CreatedModel.KPI !== '' && this.CreatedModel.nests.length > 1 && this.CreatedModel.initial_annual_spend['table-data']['Channels'].length > 0) {
        this.Validate['step1'] = true;
        return true;
      } else {
        this.Validate['step1'] = false;
        return false;
      }
    },
    validateSecondStep: function validateSecondStep() {
      var weekSalesObj = this.CreatedModel.total_weekly_sales['table-data'].weekly_base_sales;
      this.Validate['step2'] = true;
      for (var week in weekSalesObj) {
        if (weekSalesObj[week] === '' || isNaN(weekSalesObj[week])) {
          this.Validate['step2'] = false;
        }
      }
      if (this.Validate['step2']) {
        this.Validate['step2'] = true;
        return true;
      } else {
        this.Validate['step2'] = false;
        return false;
      }
    },
    validateThirdStep: function validateThirdStep() {
      var paidMediaObj = this.CreatedModel.initial_annual_spend['table-data']['Annual spend'];
      this.Validate['step3'] = true;
      if (paidMediaObj.length === this.CreatedModel.initial_annual_spend['table-data']['Channels'].length) {
        for (var spend in paidMediaObj) {
          if (paidMediaObj[spend] === '' || isNaN(paidMediaObj[spend])) {
            this.Validate['step3'] = false;
          }
        }
      } else {
        this.Validate['step3'] = false;
      }
      if (this.Validate['step3']) {
        this.Validate['step3'] = true;
        return true;
      } else {
        this.Validate['step3'] = false;
        return false;
      }
    },
    validateFourthStep: function validateFourthStep() {
      var ccsRichObj = this.CreatedModel.ccs['table-data'];
      var ccsSizeObj = this.CreatedModel.size_propensity['table-data'];
      this.Validate['step4'] = true;
      this.ccsRemove = true;
      for (var ccs in ccsRichObj) {
        if (ccsRichObj[ccs].length > 0 && ccs !== 'Channels') {
          this.ccsRemove = false;
        }
      }
      for (var size in ccsSizeObj) {
        if (ccsSizeObj[size].length > 0 && size !== 'Size') {
          this.ccsRemove = false;
        }
      }
      if (!this.ccsRemove) {
        for (var ccsVal in ccsRichObj) {
          for (var val in ccsRichObj[ccsVal]) {
            if ((ccsRichObj[ccsVal][val] === '' || isNaN(ccsRichObj[ccsVal][val]) || ccsRichObj[ccsVal].length !== ccsRichObj['Channels'].length) && ccsVal !== 'Channels') {
              this.Validate['step4'] = false;
            }
          }
        }
        for (var sizeVal in ccsSizeObj) {
          for (var _val in ccsSizeObj[sizeVal]) {
            if ((ccsSizeObj[sizeVal][_val] === '' || isNaN(ccsSizeObj[sizeVal][_val]) || ccsSizeObj[sizeVal].length !== ccsSizeObj['Size'].length) && sizeVal !== 'Size') {
              this.Validate['step4'] = false;
            }
          }
        }
      }
      if (this.Validate['step4']) {
        this.Validate['step4'] = true;
        return true;
      } else {
        this.Validate['step4'] = false;
        return false;
      }
    }
  },
  destroyed: function destroyed() {
    this.CreatedModel = [];
    this.ViewModel = '';
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);




var $ = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DemoGrid',
  components: { Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a },
  props: {
    data: Array,
    columns: Array,
    filterKey: String,
    pagination: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    sortKeys: Array
  },
  data: function data() {
    var sortOrders = {};
    this.columns.forEach(function (key) {
      sortOrders[key] = 1;
    });
    return {
      sortKey: '',
      sortOrders: sortOrders,
      settingPopupStyle: {},
      currentJobView: '',
      currententPointData: [],
      viewButton: false
    };
  },
  computed: {
    filteredData: function filteredData() {
      var _this = this;

      var sortKey = this.sortKey;
      var filterKey = this.filterKey && this.filterKey.toLowerCase();
      var order = this.sortOrders[sortKey] || 1;
      var data = this.data;
      if (filterKey) {
        data = data.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        });
      }
      if (sortKey) {
        if (this.isSortKey(sortKey)) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey];
            b = b[sortKey];
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          });
        }
      }
      return data.filter(function (row, indexOf) {
        var start = (_this.pagination.currentPage - 1) * _this.pagination.dataPage;
        var end = _this.pagination.currentPage * _this.pagination.dataPage;
        if (indexOf >= start && indexOf < end) {
          return true;
        }
      });
    },
    pageLinks: function pageLinks() {
      if (this.pagination.totalPages === undefined) {
        return [];
      }
      var arr = [];
      var preDots = false;
      var postDots = false;
      for (var i = 1; i <= this.pagination.totalPages; i++) {
        if (this.pagination.totalPages <= 10) {
          arr.push(i);
        } else {
          if (i === 1) {
            arr.push(i);
          } else if (i === this.pagination.totalPages) {
            arr.push(i);
          } else if (i > this.pagination.currentPage - 4 && i < this.pagination.currentPage + 4 || i < 4 && this.pagination.currentPage < 4 || i > this.pagination.totalPages - 4 && this.pagination.currentPage > this.pagination.totalPages - 4) {
            arr.push(i);
          } else if (i < this.pagination.currentPage && !preDots) {
            arr.push('...');
            preDots = true;
          } else if (i > this.pagination.currentPage && !postDots) {
            arr.push('...');
            postDots = true;
          }
        }
      }
      return arr;
    },
    shouldShowPagination: function shouldShowPagination() {
      if (this.pagination.totalPages === undefined) {
        return false;
      }
      if (this.pagination.count === 0) {
        return false;
      }
      return this.pagination.totalPages > 1;
    }
  },
  filters: {
    capitalize: function capitalize(str) {
      str = str.charAt(0).toUpperCase() + str.slice(1);
      return str;
    },
    prettifyCamelCase: function prettifyCamelCase(str) {
      var output = '';
      var len = str.length;
      var char;
      for (var i = 0; i < len; i++) {
        char = str.charAt(i);
        if (i === 0) {
          output += char.toUpperCase();
        } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
          output += ' ' + char;
        } else if (char === '-' || char === '_') {
          output += ' ';
        } else {
          output += char;
        }
      }
      return output;
    }
  },
  methods: {
    errorPopup: function errorPopup() {
      var err = {
        title: 'Data Error',
        message: ' ',
        type: 'error',
        customClass: 'error'
      };
      this.$refs.simplert.openSimplert(err);
    },
    settingPopupClose: function settingPopupClose() {
      this.currentJobView = '';
      this.$refs.settingPopup.classList.remove('active');
      this.currententPointData = [];
      $('.model-history .highlitetr').removeClass('highlitetr');
      this.viewButton = false;
    },
    openSetting: function openSetting(entPointData, objevent) {
      var clientattrib = objevent.currentTarget.getClientRects();
      var xPos = clientattrib[0].left - 40;
      var yPos = clientattrib[0].top - 10;
      console.log(entPointData);
      console.log(objevent, xPos, yPos);
      this.currentJobView = entPointData['Access Report'];
      this.currententPointData = entPointData;

      this.$refs.settingPopup.style.left = xPos + 'px';
      this.$refs.settingPopup.style.top = yPos + 'px';
      this.$refs.settingPopup.classList.add('active');
      $('.model-history .highlitetr').removeClass('highlitetr');
      this.viewButton = true;
      objevent.currentTarget.parentNode.parentNode.parentElement.classList.add('highlitetr');
    },
    removeSelectedJobAlert: function removeSelectedJobAlert(entPointData, objevent) {
      var entPointDatain = entPointData;
      var objeventin = objevent;
      var self = this;
      var confirmCloseModal = {
        title: 'Are you sure you want to delete Model?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function onConfirm() {
          self.removeSelectedJob(entPointDatain, objeventin);
        }
      };
      this.$refs.simplert.openSimplert(confirmCloseModal);
    },
    removeSelectedJob: function removeSelectedJob(entPointData, objevent) {
      var jobtodel = entPointData['Access Report'];
      var self = this;
      jobtodel = jobtodel.replace('job-id=', '');
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/velocitydeletemodel',
        data: { 'user-id': window.localStorage.getItem('user'), 'job-id': jobtodel },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          self.loadingtext = 'processing...';
          $('.spinner').show();
        },
        complete: function complete() {
          self.settingPopupClose();
          self.viewButton = false;
          $('.spinner').hide();
        },
        success: function success(data) {
          console.log(data);
          window.location.reload();
          return data;
        },
        error: function error(data, _error) {
          console.log(data);
          console.log(_error);
          $('.spinner').hide();
          self.errorPopup();
        }
      });
    },

    sortBy: function sortBy(key) {
      if (this.sortOrders[key] === undefined) {
        var orders = {};
        this.columns.forEach(function (key) {
          orders[key] = 1;
        });
        this.sortOrders = orders;
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      } else {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      }
    },
    setJobId: function setJobId(jobId) {
      var jId = jobId['Access Report'];
      var ver = jobId.version_id;
      window.localStorage.setItem('JobId', jId);
      window.localStorage.setItem('JobVersion', ver);
      this.$router.push('/report');
    },
    isActive: function isActive(page) {
      var currentPage = this.pagination.currentPage || 1;
      return currentPage === page;
    },
    pageClicked: function pageClicked(page) {
      if (page === '...' || page === this.pagination.currentPage || page > this.pagination.totalPages || page < 1) {
        return;
      }
      this.$emit('pageChange', page);
    },

    getData: function getData() {
      var sortOrders = {};
      this.columns.forEach(function (key) {
        sortOrders[key] = 1;
      });
      return {
        sortOrders: sortOrders
      };
    },
    isSortKey: function isSortKey(key) {
      var length = this.sortKeys.length;
      for (var i = 0; i < length; i++) {
        if (this.sortKeys[i] === key) return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_handsontable_official__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_handsontable_official___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_handsontable_official__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HotTable: __WEBPACK_IMPORTED_MODULE_1_vue_handsontable_official___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  props: ['inputData', 'createdObject', 'validate'],
  data: function data() {
    return {
      ccsRichData: this.createdObject.ccs['table-data'],
      cssSizeData: this.createdObject.size_propensity['table-data'],
      addHeader: 1,
      checkValidate: '',
      CSSRichId: 'css-rich',
      CSSRich: {
        autoWrapRow: true,
        height: 250,
        colWidths: 150,
        data: [],
        colHeaders: [],
        allowInsertRow: false,
        className: 'esheetclass',
        outsideClickDeselects: false,
        invalidCellClassName: 'htInvalid',
        tableClassName: 'exceltablestyle ccstable createtable',
        fillHandle: {
          autoInsertRow: false
        },
        afterChange: this.CSSRichChanged,
        init: this.updateCCSRich,
        columns: []
      },
      CSSSizeId: 'css-size',
      CSSSize: {
        height: 130,
        colWidths: 150,
        data: [],
        colHeaders: [],
        allowInsertRow: false,
        className: 'esheetclass',
        invalidCellClassName: 'htInvalid',
        tableClassName: 'exceltablestyle ccstable createtable',
        fillHandle: {
          autoInsertRow: false
        },
        afterChange: this.CSSSizeChanged,
        init: this.updateCCSSize,
        columns: []
      }
    };
  },

  watch: {
    checkValidate: function checkValidate(val) {
      if (!val) {
        this.$refs.CSSRichId.table.validateCells();
        this.$refs.CSSSizeId.table.validateCells();
      }
    }
  },
  activated: function activated() {
    var ccs = 0;
    var loopVar = 1;
    var ccsLength = this.CSSRich.data.length;
    while (loopVar <= ccsLength - 1) {
      if (ccs < 0) {
        ccs = 0;
      }
      if (this.ccsRichData['Channels'][ccs] !== undefined) {
        if (this.CSSRich.data[ccs + 1][0] !== this.ccsRichData['Channels'][ccs]) {
          this.$refs.CSSRichId.table.alter('remove_row', ccs + 1);
          --ccs;
        } else {
          ++ccs;
        }
      } else {
        this.$refs.CSSRichId.table.alter('remove_row', ccs + 1);
      }
      loopVar++;
    }
    for (var ccsAdd in this.ccsRichData['Channels']) {
      if (this.CSSRich.data[parseInt(ccsAdd) + 1] === undefined) {
        this.$refs.CSSRichId.table.alter('insert_row', parseInt(ccsAdd) + 1);
        this.CSSRich.data[parseInt(ccsAdd) + 1][0] = this.ccsRichData['Channels'][ccsAdd];
      }
    }
  },

  methods: {
    updateCCSRich: function updateCCSRich() {
      this.CSSRich.data = [];
      var counter = 1;
      for (var key in this.ccsRichData) {
        if (this.CSSRich.columns.length < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.ccsRichData).length) {
          this.CSSRich.colHeaders.push(key);
          if (counter === 1) {
            this.CSSRich.columns.push({ readOnly: true });
          } else {
            this.CSSRich.columns.push({ readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/ });
          }
        }
        counter++;
        for (var value in this.ccsRichData[key]) {
          if (this.CSSRich.data[value] === undefined) {
            this.CSSRich.data.push([]);
          }
          this.CSSRich.data[value].push(this.ccsRichData[key][value]);
        }
      }
      this.CSSRich.data.unshift(this.CSSRich.colHeaders);
    },
    updateCCSSize: function updateCCSSize() {
      this.CSSSize.data = [];
      var counter = 1;
      for (var key in this.cssSizeData) {
        if (this.CSSSize.columns.length < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.cssSizeData).length) {
          this.CSSSize.colHeaders.push(key);
          if (counter === 1) {
            this.CSSSize.columns.push({ readOnly: true });
          } else {
            this.CSSSize.columns.push({ readOnly: false });
          }
        }
        counter++;
        for (var value in this.cssSizeData[key]) {
          if (this.CSSSize.data[value] === undefined) {
            this.CSSSize.data.push([]);
          }
          this.CSSSize.data[value].push(this.cssSizeData[key][value]);
        }
      }
      this.CSSSize.data.unshift(this.CSSSize.colHeaders);
    },
    CSSRichChanged: function CSSRichChanged(changes, source) {
      for (var key in changes) {
        var colName = this.CSSRich.colHeaders[changes[key][1]];
        var index = changes[key][0];
        if (changes[key][0] !== 0) {
          index = index - 1;
          var richValue = changes[key][3];
          if (richValue !== '' && richValue !== undefined) {
            richValue = richValue.replace(/,/gi, '');
            this.ccsRichData[colName][index] = richValue;
          } else {
            this.ccsRichData[colName][index] = richValue;
          }
        } else {
          if (this.ccsRichData.hasOwnProperty(changes[key][2])) {
            var keyValue = this.ccsRichData[changes[key][2]];
            delete this.ccsRichData[changes[key][2]];
            this.ccsRichData[changes[key][3]] = keyValue;
          }
        }
      }
      if (changes) {
        this.$emit('stepValidate');
      }
    },
    CSSSizeChanged: function CSSSizeChanged(changes, source) {
      for (var key in changes) {
        var colName = this.CSSSize.colHeaders[changes[key][1]];
        var index = changes[key][0];
        if (changes[key][0] !== 0) {
          index = index - 1;
          var sizeValue = changes[key][3];
          if (sizeValue !== '' && sizeValue !== undefined) {
            sizeValue = sizeValue.replace(/,/gi, '');
            this.cssSizeData[colName][index] = sizeValue;
          } else {
            this.cssSizeData[colName][index] = sizeValue;
          }
        } else {
          if (this.cssSizeData.hasOwnProperty(changes[key][2])) {
            var keyValue = this.cssSizeData[changes[key][2]];
            delete this.cssSizeData[changes[key][2]];
            this.cssSizeData[changes[key][3]] = keyValue;
          }
        }
      }
      if (changes) {
        this.$emit('stepValidate');
      }
    },
    addSegment: function addSegment() {
      if (this.CSSRich.columns.length < 12) {
        var segmentName = 'Segment ' + this.addHeader;
        this.CSSRich.columns.push({ readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/ });
        this.CSSSize.columns.push({ readOnly: false, validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/ });
        this.CSSRich.colHeaders.push(segmentName);
        this.CSSSize.colHeaders.push(segmentName);
        this.ccsRichData[segmentName] = [];
        this.cssSizeData[segmentName] = [];
        ++this.addHeader;
      }
    },
    deleteSegment: function deleteSegment() {
      if (this.CSSRich.columns.length > 2) {
        var removeItem = this.$refs.CSSRichId.table.getSelected();
        if (removeItem !== undefined && removeItem[1] > 1) {
          var that = this;
          var confirmDelete = {
            title: '',
            message: 'Are you sure to delete?',
            type: 'info',
            useConfirmBtn: true,
            customConfirmBtnText: 'Yes',
            customCloseBtnText: 'No',
            customConfirmBtnClass: 'btn btn-primary',
            customCloseBtnClass: 'btn btn-primary',
            onConfirm: function onConfirm() {
              var colName = that.CSSRich.colHeaders[removeItem[1]];
              that.CSSRich.colHeaders.splice(removeItem[1], 1);
              that.CSSRich.columns.splice(removeItem[1], 1);
              that.CSSSize.colHeaders.splice(removeItem[0] - 1, 1);
              that.CSSSize.columns.splice(removeItem[0] - 1, 1);
              delete that.ccsRichData[colName];
              delete that.cssSizeData[colName];
            }
          };
          this.$refs.simplert.openSimplert(confirmDelete);
        } else {
          var deleteCol = {
            title: '',
            message: 'Please select CCS Rich Segment Column to delete',
            type: 'error',
            customCloseBtnClass: 'btn btn-primary'
          };
          this.$refs.simplert.openSimplert(deleteCol);
        }
      }
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DemoGrid__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DemoGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DemoGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Create_model_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Create_model_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Create_model_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_simplert__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModelHistory',
  components: { DemoGrid: __WEBPACK_IMPORTED_MODULE_3__DemoGrid___default.a, CreateModel: __WEBPACK_IMPORTED_MODULE_5__Create_model_vue___default.a, Simplert: __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default.a },
  data: function data() {
    return {
      loadingtext: '',
      searchQuery: '',
      modelType: '',
      gridColumns: [],
      gridData: [],
      pagination: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      dataPage: 10,
      pages: Number,
      showModal: false,
      sortKeys: ['Name', 'Country', 'Category', 'Created By']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: localStorage.getItem('username'),
        avatar: '/static/img/stock/user.png',
        email: localStorage.getItem('email'),
        randomCard: ''
      };
    }
  }),
  methods: {
    popupnoModel: function popupnoModel() {
      var popupnoModel = {
        title: 'No Model Present',
        message: 'Click to Create Model',
        type: 'info',
        customCloseBtnClass: 'btn btn-primary',
        onClose: this.closecreate,
        customCloseBtnText: 'Create Model'
      };
      this.$refs.simplert.openSimplert(popupnoModel);
    },
    closecreate: function closecreate() {
      this.showModel('create');
    },
    getData: function getData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetUserModels',
        data: { 'user-id': window.localStorage.getItem('user') },
        async: true,
        contentType: 'application/json',
        headers: { 'x-api-key': window.localStorage.getItem('XpiKey') },
        beforeSend: function beforeSend() {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.spinner').show();
          self.loadingtext = 'fetching your models...';
          setTimeout(function () {
            self.loadingtext = 'almost done!';
          }, 2000);
        },
        complete: function complete(data) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.spinner').hide();
        },
        success: function success(data) {
          data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data['output']));
          data['Columns'].splice(5);
          data['Rows'].forEach(function (currentValue, index) {
            delete currentValue.Comments;
          });
          self.gridColumns = data['Columns'];
          self.gridData = data['Rows'];
          var pages = self.count(self.gridData) / self.dataPage;
          pages = Math.ceil(pages);
          self.pagination = { 'totalPages': pages, 'currentPage': 1, 'dataPage': self.dataPage };
          if (data['Rows'].length === 0) {
            self.popupnoModel();
            return;
          }
        },
        error: function error(data, _error) {
          console.log(data);
          console.log(_error);
          self.displaydownloadError();
        } });
    },

    count: function count(obj) {
      var count = 0;
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          ++count;
        }
      }
      return count;
    },
    filterData: function filterData() {
      delete self.gridColumns['Columns'][5];
      self.gridData['Rows'].forEach(function (currentValue, index) {
        delete currentValue.Comments;
      });
    },
    pageChange: function pageChange(page) {
      this.pagination.currentPage = page;
    },
    modelepopuponClose: function modelepopuponClose() {
      this.$router.push('/report');
    },
    ModelCreated: function ModelCreated() {
      var modelCreatedModal = {
        title: 'Model Created',
        message: '',
        type: 'success',
        customCloseBtnClass: 'btn btn-primary',
        onClose: this.modelepopuponClose
      };
      this.$refs.simplert.openSimplert(modelCreatedModal);
    },
    closeModal: function closeModal() {
      if (this.modelType === 'view') {
        this.showModal = false;
      } else {
        var that = this;
        var confirmCloseModal = {
          title: 'Are you sure you want to close Create Model?',
          type: 'info',
          useConfirmBtn: true,
          customConfirmBtnText: 'Yes',
          customCloseBtnText: 'No',
          customConfirmBtnClass: 'btn btn-primary',
          customCloseBtnClass: 'btn btn-primary',
          onConfirm: function onConfirm() {
            that.showModal = false;
          }
        };
        this.$refs.simplert.openSimplert(confirmCloseModal);
      }
    },
    showModel: function showModel(type, jobId) {
      this.modelType = type;
      this.showModal = true;
      if (type === 'view') {
        window.localStorage.setItem('JobId', jobId);
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getData();
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data: function data() {
    return {
      modelName: '',
      modelKPI: '',
      EarnedMediaValue: '',
      PaidMediaValue: '',
      SelectedCategories: [],
      SelectedPaidMedia: [],
      SelectedEarnedMedia: [],
      selectedCountry: [],
      SelectedCurrency: '',
      annualSpend: this.createdObject.initial_annual_spend['table-data'],
      ccsReach: this.createdObject.ccs['table-data']
    };
  },

  watch: {
    viewObject: function viewObject() {
      if (this.modelType === 'view') {
        this.updateView();
      }
    }
  },
  methods: {
    countryChanged: function countryChanged(selectedValue) {
      this.SelectedEarnedMedia = [];
      if (selectedValue !== 'false') {
        this.SelectedCategories = this.inputData[selectedValue].Category;
        this.SelectedCurrency = this.inputData[selectedValue].currency;
        if (this.inputData[selectedValue].Paid_Media.indexOf('Press') !== -1) {
          var pressIndex = this.inputData[selectedValue].Paid_Media.indexOf('Press');
          this.SelectedPaidMedia = this.inputData[selectedValue].Paid_Media;
          this.SelectedPaidMedia.splice(pressIndex, 1, 'Print');
        } else {
          this.SelectedPaidMedia = this.inputData[selectedValue].Paid_Media;
        }
        this.createdObject.country = selectedValue;
      } else {
        this.SelectedCategories = [];
        this.SelectedMediaChannel = [];
        this.createdObject.country = '';
        this.createdObject.market = '';
        alert('Please Select the Country');
        return false;
      }
    },
    categoryChanged: function categoryChanged(selectedValue) {
      if (selectedValue !== 'false') {
        this.SelectedEarnedMedia = this.SelectedCategories[selectedValue].Media.filter(function (value) {
          return value !== 'Sales';
        });
        this.createdObject.market = selectedValue;
      } else {
        this.SelectedEarnedMedia = [];
        this.createdObject.market = '';
        alert('Please Select the Category');
        return false;
      }
    },
    GetEarnedMedia: function GetEarnedMedia(value) {
      this.createdObject.nests.push(value);
    },
    removeEarnedMedia: function removeEarnedMedia(removedOption) {
      var filteredEarnedMedia = this.createdObject.nests.filter(function (value) {
        return value !== removedOption;
      });
      this.createdObject.nests = filteredEarnedMedia;
    },
    GetPaidMedia: function GetPaidMedia(value) {
      if (value === 'Print') {
        value = 'Press';
      }
      this.annualSpend['Channels'].push(value.trim());
      this.ccsReach['Channels'].push(value.trim());
    },
    removePaidMedia: function removePaidMedia(removedOption) {
      if (removedOption === 'Print') {
        removedOption = 'Press';
      }
      var removeSpendIndex = this.ccsReach['Channels'].indexOf(removedOption);
      for (var ccs in this.ccsReach) {
        if (this.ccsReach[ccs].length > removeSpendIndex) {
          this.ccsReach[ccs].splice(removeSpendIndex, 1);
        }
      }
      var removeCcsIndex = this.annualSpend['Channels'].indexOf(removedOption);
      for (var spend in this.annualSpend) {
        if (this.annualSpend[spend].length > removeCcsIndex) {
          this.annualSpend[spend].splice(removeCcsIndex, 1);
        }
      }
    },
    updateView: function updateView() {
      this.modelName = this.viewObject.name;
      this.modelKPI = this.viewObject.KPI;
      this.EarnedMediaValue = this.viewObject.Nests;
      this.selectedCountry = this.viewObject.country;
      this.SelectedCurrency = this.viewObject.currency;
      this.PaidMediaValue = [];
      for (var key in this.viewObject.AnnualSpend) {
        this.PaidMediaValue.push(key);
      }
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HotTable: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data: function data() {
    return {
      annualSpend: this.createdObject.initial_annual_spend['table-data'],
      paidMediaId: 'paid-media',
      checkValidate: '',
      totalBudget: 0,
      paidMedia: {
        autoWrapRow: true,
        width: 600,
        height: 287,
        maxColsNumber: 2,
        colWidths: 180,
        data: [],
        colHeaders: ['Paid Media', 'Total Budget'],
        className: 'esheetclass view-only',
        tableClassName: 'exceltablestyle createtable paid-media',
        allowInsertRow: false,
        fillHandle: {
          autoInsertRow: false
        },
        invalidCellClassName: 'htInvalid',
        beforePaste: this.mediaPaste,
        columns: [{
          data: 'name',
          readOnly: true
        }, {
          validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/
        }],
        cells: function cells(row, col, prop) {
          var cellProperties = {};
          if (col === 1 && row === this.instance.getData().length - 1) {
            cellProperties.readOnly = true;
          }
          return cellProperties;
        }
      }
    };
  },
  activated: function activated() {
    if (this.modelType === 'view') {
      this.totalBudget = 0;
      for (var col in this.paidMedia.columns) {
        this.paidMedia.columns[col].readOnly = true;
      }
      this.paidMedia.data = [];
      for (var spend in this.viewObject.AnnualSpend) {
        this.paidMedia.data.push({ name: this.viewObject.AnnualSpend[spend].name, 1: this.viewObject.AnnualSpend[spend].spend });
        this.totalBudget += this.viewObject.AnnualSpend[spend].spend;
      }
      this.paidMedia.data.push({ 'name': 'Total Budget', 1: this.totalBudget });
    } else if (this.modelType === 'create') {
      this.paidMedia.afterChange = this.paidMediaChanged;
      this.paidMedia.init = this.updateMedia;
      var addTotal = '';
      var _spend = 0;
      var loopVar = 1;
      var spendLength = this.paidMedia.data.length;
      while (loopVar <= spendLength) {
        if (_spend < 0) {
          _spend = 0;
        }
        if (this.annualSpend['Channels'][_spend] !== undefined) {
          if (this.paidMedia.data[_spend].name !== this.annualSpend['Channels'][_spend]) {
            this.$refs.paidMediaId.table.alter('remove_row', _spend);
            --_spend;
          } else {
            ++_spend;
          }
        } else {
          if (this.paidMedia.data[_spend].name !== 'Total Budget') {
            this.$refs.paidMediaId.table.alter('remove_row', _spend);
          }
        }
        loopVar++;
      }
      for (var spendAdd in this.annualSpend['Channels']) {
        if (this.paidMedia.data[parseInt(spendAdd)] === undefined) {
          this.$refs.paidMediaId.table.alter('insert_row', parseInt(spendAdd));
          this.paidMedia.data[parseInt(spendAdd)].name = this.annualSpend['Channels'][spendAdd];
          addTotal = true;
        }
      }
      if (addTotal && addTotal !== '') {
        this.paidMedia.data.push({ 'name': 'Total Budget', 1: 0 });
      }
      this.totalBudgetFunc();
    }
  },

  watch: {
    checkValidate: function checkValidate(val) {
      if (!val) {
        this.$refs.paidMediaId.table.validateCells();
      }
    }
  },
  methods: {
    paidMediaChanged: function paidMediaChanged(changes, source) {
      for (var key in changes) {
        var spendValue = changes[key][3];
        spendValue = spendValue.replace(/,/gi, '');
        this.annualSpend['Annual spend'][changes[key][0]] = spendValue;
      }
      this.totalBudgetFunc();
      if (changes) {
        this.$emit('stepValidate');
      }
    },
    totalBudgetFunc: function totalBudgetFunc() {
      this.totalBudget = 0;
      for (var val in this.annualSpend['Annual spend']) {
        var validNum = new RegExp(/^\d+[.]?\d+$/);
        if (validNum.test(this.annualSpend['Annual spend'][val])) {
          this.totalBudget += parseInt(this.annualSpend['Annual spend'][val]);
        }
      }
      this.paidMedia.data[this.paidMedia.data.length - 1][1] = this.totalBudget;
    },
    updateMedia: function updateMedia() {
      this.paidMedia.data = [];
      for (var key in this.annualSpend['Channels']) {
        var annualSpendValue = this.annualSpend['Annual spend'][key];
        if (annualSpendValue === undefined) {
          annualSpendValue = '';
        }
        this.paidMedia.data.push({ 'name': this.annualSpend['Channels'][key] });
        if (annualSpendValue !== undefined) {
          this.paidMedia.data[key][1] = annualSpendValue;
        }
      }
      this.paidMedia.data.push({ 'name': 'Total Budget', 1: 0 });
    },
    mediaPaste: function mediaPaste(data, coords) {
      if (data.length > this.annualSpend['Channels'].length) {
        var modelCreatedModal = {
          title: '',
          message: 'Please add values for ' + this.annualSpend['Channels'].length + ' Media only',
          type: 'error',
          customCloseBtnClass: 'btn btn-primary'
        };
        this.$refs.simplert.openSimplert(modelCreatedModal);
        return false;
      } else {
        this.validate['step3'] = true;
      }
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    HotTable: __WEBPACK_IMPORTED_MODULE_0_vue_handsontable_official___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data: function data() {
    return {
      totalWeek: this.createdObject.total_weekly_sales['table-data'],
      salesTableId: 'week-sales',
      checkValidate: '',
      base_sales_flag: false,
      weekSales: {
        autoWrapRow: true,
        height: 287,
        colWidths: 120,
        maxColsNumber: 2,
        data: [],
        allowInsertRow: false,
        colHeaders: ['Week No.', 'Total ' + this.createdObject.KPI],
        fillHandle: {
          autoInsertRow: false
        },
        className: 'esheetclass view-only',
        tableClassName: 'exceltablestyle createtable',
        afterChange: this.perWeekChanged,
        beforePaste: this.weekPaste,
        invalidCellClassName: 'htInvalid',
        columns: [{
          data: 'name',
          readOnly: true
        }, {
          validator: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/
        }]
      }
    };
  },
  created: function created() {
    for (var i = 1; i <= 52; i++) {
      this.weekSales.data.push({ name: 'Week ' + i, value: '' });
    }
    if (this.modelType === 'view') {
      this.createdObject.base_sales_flag = this.viewObject.base_sales_flag;
      for (var col in this.weekSales.columns) {
        this.weekSales.columns[col].readOnly = true;
      }
      for (var week in this.viewObject.Weekly_Sales) {
        this.weekSales.data[week][1] = this.viewObject.Weekly_Sales[week].value.toString();
      }
    }
  },
  activated: function activated() {
    this.weekSales.colHeaders = ['Week No.', 'Total ' + this.createdObject.KPI];
    if (!this.validate['step2']) {
      this.$refs.salesTableId.table.validateCells();
    }
  },

  watch: {
    checkValidate: function checkValidate(val) {
      if (!val) {
        this.$refs.salesTableId.table.validateCells();
      }
    }
  },
  methods: {
    perWeekChanged: function perWeekChanged(changes, source) {
      this.totalWeek['week_no'] = [];
      this.totalWeek['weekly_base_sales'] = [];
      for (var week in this.weekSales.data) {
        var sales = this.weekSales.data[week][1];
        if (sales !== undefined && sales !== '') {
          sales = sales.replace(/,/gi, '');
        }
        this.totalWeek['week_no'].push(parseInt(week) + 1);
        this.totalWeek['weekly_base_sales'].push(parseInt(sales));
      }
      if (changes) {
        this.$emit('stepValidate');
      }
    },
    weekPaste: function weekPaste(data, coords) {
      if (data.length > 52) {
        var modelCreatedModal = {
          title: '',
          message: 'Please add values for 52 weeks only',
          type: 'error',
          customCloseBtnClass: 'btn btn-primary'
        };
        this.$refs.simplert.openSimplert(modelCreatedModal);
        return false;
      } else {
        this.validate['step2'] = true;
      }
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vis__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_handsontable_official__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_handsontable_official___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_handsontable_official__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);












var $ = __WEBPACK_IMPORTED_MODULE_8_jquery___default.a;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ovs-network',
  components: { vueSlider: __WEBPACK_IMPORTED_MODULE_5_vue_slider_component___default.a, HotTable: __WEBPACK_IMPORTED_MODULE_6_vue_handsontable_official___default.a, Simplert: __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default.a },
  data: function data() {
    return {
      enableCompare: false,
      currencySymbol: '',
      modelVesrionSelect: 0,
      versionName: '',
      versions: [],
      NewOptimiseClick: false,
      Tkpi: 'Sale',
      currenttoggle: this.kpi,
      sliderLength: 0,
      excelHeight: 0,
      loadingtext: '',
      currentnest_name: '',
      updateBtnDisable: true,
      validationArray: [],
      cellChanges: [],
      root: 'test-hot',
      reportj: [],
      dupreportj: [],
      currentNest: [],
      observeChanges: true,
      category: '',
      country: '',
      modelname: '',
      datachangeobj: [],
      kpi: 'Sales',
      hotSettings: {
        afterChange: function afterChange(changes, source) {
          if (this.isListening()) {
            var maup = this.getActiveEditor();
            if (maup.originalValue === 0) {
              return false;
            }
            this.rootElement.__vue__.$parent.dupreportj = this.rootElement.__vue__.$parent.reportj;
            this.rootElement.__vue__.$parent.updateBtnDisable = false;
            var datachangeobj = this.getData();

            if (this.rootElement.__vue__.$parent.datachangeobj.length === 0) {
              this.rootElement.__vue__.$parent.currentNest = [];
              var nestNname = this.getColHeader()[1];
              nestNname = nestNname.split(' %')[0];
              nestNname = String(nestNname);
              this.rootElement.__vue__.$parent.currentnest_name = nestNname;
              nestNname = nestNname.replace(/\s/gi, '_');
              var nestobj = {
                'nest_name': nestNname,
                'channel': datachangeobj
              };
              this.rootElement.__vue__.$parent.dupreportj.asymptote_values[nestNname].channel;
              this.rootElement.__vue__.$parent.updateBtnDisable = false;
              this.rootElement.__vue__.$parent.datachangeobj.push(nestobj);
              this.rootElement.__vue__.$parent.currentNest.push(nestobj);
            }
          }

          this.rootElement.__vue__.$parent.datachangeobj = [];
          if (!changes) {
            return;
          }
          if (source === 'edit') {
            var that = this;
            var colIndex = 1;
            var getData = this.getData();
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(getData).forEach(function (rowIndex) {
              var element = that.getCell(rowIndex, colIndex);
              if (getData[rowIndex][1] === '') {
                setTimeout(function () {
                  element.className = 'emptyCells';
                }, 0);
              }
            });
          }
        },
        autoWrapRow: true,
        width: 500,
        height: 200,
        maxRows: 10,
        maxColsNumber: 2,
        colWidths: 230,
        className: 'esheetclass',
        tableClassName: 'exceltablestyle',
        colHeaders: [' ', ''],
        data: [],
        columns: [{
          data: 'name',
          readOnly: true
        }, {
          data: 'value'
        }],
        disableVisualSelection: true
      },
      gridcolumns: [{
        title: 'Id',
        name: 'id',
        editable: false
      }, {
        title: 'Firstname',
        name: 'firstname',
        editable: true
      }, {
        title: 'Lastname',
        name: 'lastname',
        editable: true
      }, {
        title: 'Email',
        name: 'email',
        editable: true
      }],
      gridoptions: {
        showSearchFilter: false,
        requests: {
          allUrl: 'http://api.dev/api/users'
        }
      },
      sliderinputval: [],
      BaseSales: [],
      TotalSpent: 0,
      TotalSpentarr: [],
      MediaDrivenSales: [],
      EcosystemSales: [],
      CompareTotalSpent: 0,
      CompareEcosystemSales: [],
      CompareTotalSales: [],
      CompareMediaDrivenSales: [],
      CompareTotalSpentArrow: 0,
      CompareEcosystemSalesArrow: 0,
      CompareTotalSalesArrow: 0,
      CompareMediaDrivenSalesArrow: 0,
      EcosystemROI: 0,
      MediaDrivenROI: 0,
      TotalSales: [],
      showtooltip: false,
      tooltipcontent: '',
      clickcheck: [0],
      paidmediaCheck: [],
      slideroptions: {
        eventType: 'auto',
        direction: 'horizontal',
        height: 8,
        width: '50%',
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: 100,
        sliderStyle: [{
          'backgroundColor': '#ce785b',
          'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        }],
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        autoResize: true,
        'piecewise-Style': {
          'backgroundColor': '#ce785b',
          'visibility': 'visible',
          'width': '12px',
          'height': '12px'
        },
        piecewiseActiveStyle: {
          'backgroundColor': '#ce785b'
        },
        labelActiveStyle: {
          'backgroundColor': '#ce785b'
        },
        tooltipStyle: {
          'backgroundColor': '#000',
          'borderColor': '#f05b72'
        },
        piecewiseLabel: false,
        tooltip: 'always',
        tooltipDir: 'top',
        reverse: false,
        data: null,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: {
          'backgroundColor': '#d8d8d8'
        },
        processStyle: {
          'backgroundColor': '#ce785b'
        }
      },
      network: null,
      nodes: [],
      addnodes: [],
      edges: [],
      addedges: [],
      options: {
        physics: {
          'enabled': false,
          'forceAtlas2Based': {
            'gravitationalConstant': -133,
            'centralGravity': 0.15,
            'springLength': 40,
            'springConstant': 0.345,
            'damping': 1,
            'avoidOverlap': 1
          },
          'maxVelocity': 57,
          'minVelocity': 0.01,
          'solver': 'forceAtlas2Based',
          'timestep': 0.01,
          stabilization: {
            enabled: true,
            iterations: 100,
            updateInterval: 100,
            onlyDynamicEdges: true,
            fit: true
          }
        },
        layout: {
          randomSeed: 1,
          improvedLayout: true,
          hierarchical: {
            enabled: true,
            levelSeparation: 65,
            nodeSpacing: 120,
            treeSpacing: 150,
            blockShifting: true,
            edgeMinimization: true,
            parentCentralization: true,
            direction: 'UD',
            sortMethod: 'hubsize' }
        },
        nodes: {
          chosen: true,
          borderWidthSelected: 8,
          shape: 'dot',
          size: 30,
          scaling: {
            min: 10,
            max: 30,
            label: {
              enabled: false,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function customScalingFunction(min, max, total, value) {
              if (max === min) {
                return 0.5;
              } else {
                var scale = 1 / (max - min);
                return Math.max(0, (value - min) * scale);
              }
            }
          }
        },
        edges: {
          'smooth': {
            'type': 'curvedCW',
            'roundness': 0.45
          },
          arrowStrikethrough: true,
          chosen: true,
          color: {
            inherit: 'from',
            opacity: 1.0
          },
          scaling: {
            min: 1,
            max: 5,
            label: {
              enabled: true,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function customScalingFunction(min, max, total, value) {
              if (max === min) {
                return 0.5;
              } else {
                var scale = 1 / (max - min);
                return Math.max(0, (value - min) * scale);
              }
            }
          },
          selectionWidth: 1,
          selfReferenceSize: 20
        },
        interaction: {
          dragNodes: true,
          dragView: false,
          hideEdgesOnDrag: false,
          hideNodesOnDrag: false,
          hover: true,
          hoverConnectedEdges: true,
          keyboard: {
            enabled: false,
            speed: { x: 10, y: 10, zoom: 0.02 },
            bindToWindow: true
          },
          multiselect: true,
          navigationButtons: true,
          selectable: true,
          selectConnectedEdges: true,
          tooltipDelay: 0,
          zoomView: false
        },
        manipulation: {
          enabled: true,
          addNode: true,
          addEdge: true
        },
        configure: {
          enabled: false,
          filter: 'nodes,edges'
        }
      },
      container: '',
      disabled: false
    };
  },

  watch: {
    excelHeight: function excelHeight(params) {
      var lenghtinslider = this.sliderLength + 1;
      var slidertopheight = lenghtinslider * 46 + 40;
      $('.excelwrapper').height(slidertopheight);
      $('.handsontableReport').height(slidertopheight);
    }
  },
  computed: {},
  methods: {
    modelVesrionSelectChanged: function modelVesrionSelectChanged() {
      var self = this;
      var jobId = window.localStorage.getItem('JobId');
      var versionid = self.versions[self.modelVesrionSelect].version_id;
      jobId = jobId.replace('job-id=', '');
      __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/getecosystemoutput',
        async: true,
        contentType: 'application/json',
        data: { 'job-id': jobId, 'user-id': window.localStorage.getItem('user'), 'nest': 'all', 'version-id': versionid },
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          $('.spinner').show();
          self.loadingtext = 'applying new values...';
          setTimeout(function () {
            self.loadingtext = 'adjusting calculations...';
          }, 200);
          setTimeout(function () {
            self.loadingtext = 'almost done!';
          }, 300);
        },
        complete: function complete() {
          console.log(self);

          $('.spinner').hide();
        },
        success: function success(data) {
          data = data['output'];

          try {
            self.reportj = data;
            self.sliderinputval = self.reportj.AnnualSpend;
            self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

            self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.EcosystemROI = self.reportj.EcosystemROI;
            self.MediaDrivenROI = self.reportj.MediaDrivenROI;
            var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(self.reportj.AnnualSpend).map(function (key) {
              return [self.reportj.AnnualSpend[key]];
            });
            if (self.reportj.compare !== undefined) {
              self.enableCompare = true;
            } else if (self.reportj.compare === undefined) {
              self.enableCompare = false;
            }
            if (self.enableCompare === true) {
              self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per;
              self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per;
              self.CompareTotalSales = self.reportj.compare.TotalSales.per;
              self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per;
              self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect;
              self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect;
              self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect;
              self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect;
              $('.highlitboxes span').css({ 'top': '-17px' });
              $('.highlitboxes label').css({ 'display': 'block' });
            } else if (self.enableCompare === false) {
              $('.highlitboxes span').css({ 'top': '-25px' });
              $('.highlitboxes label').css({ 'display': 'none' });
            }
            self.clickcheck = [];
            self.nodes = [];
            self.edges = [];
            var nodes = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.nodes);
            var edges = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.edges);
            self.reportj.nodes.forEach(function (value, index) {
              if (value.id <= 99 && value.id > 0) {
                self.reportj.edges.forEach(function (evalue, eindex) {
                  if (value.id === evalue.from) {
                    if (evalue.from < 99 && evalue.to === 0) {
                      self.nodes.push(value);
                      nodes.add(value);
                    }
                  }
                });
              } else if (value.id === 0) {
                self.nodes.push(value);
                nodes.add(value);
              } else {
                self.addnodes.push(value);
              }
            });
            self.reportj.edges.forEach(function (value, index) {
              if (value.to === 0) {
                self.edges.push(value);
                edges.add(value);
              } else {
                self.addedges.push(value);
              }
            });
            self.container = document.getElementById('mynetwork');
            var newdata = {
              nodes: nodes,
              edges: edges
            };
            self.clickcheck = [];
            window.network.setData(newdata);
            window.network = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.Network(self.container, newdata, self.options);
            window.network.on('doubleClick', function (params) {
              params.event = '[original event]';
              if (this.getNodeAt(params.pointer.DOM) === undefined) {
                return false;
              }

              var nodesDataset = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.nodes);
              var currentNodeLabel = nodesDataset.get(params.nodes)[0].id;
              self.updateHotSetting(params, nodesDataset);
              if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
                return false;
              }
              self.handleNetworkClickEvent(edges, nodes, currentNodeLabel);
            });
            window.network.on('hoverEdge', function (params, event) {
              params.event = '[original event]';
              var currentEdgeValue = this.body.data.edges.get(params.edge).title;
              self.handleHoverEdgeEvent(params, currentEdgeValue);
            });
            window.network.on('blurEdge', function (params, event) {
              params.event = '[original event]';
              self.handleNodeEdgeBlurEvent();
            });
            var changeCursor = function changeCursor(newCursorStyle) {
              var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0];
              networkCanvas.style.cursor = newCursorStyle;
            };
            window.network.on('hoverNode', function (params, event) {
              params.event = '[original event]';
              changeCursor('pointer');
              var currentEdgeValue = this.body.data.nodes.get(params.node).value;
              var currentnodename = this.body.data.nodes.get(params.node).label;
              self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename);
            });
            window.network.on('blurNode', function (params, event) {
              params.event = '[original event]';
              self.handleNodeEdgeBlurEvent();
            });
            self.TotalSpentarr = result;
            self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %'];
            self.currentNest = self.reportj.asymptote_values[self.kpi];
            self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name;
            self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel;
            self.calculatetotalspent(result);
            self.country = self.reportj.country;
            self.modelname = self.reportj.name;
            self.category = self.reportj.category;
          } catch (err) {
            console.log(err);
            $('.spinner').hide();
            self.errorPopup();
          }
          return data;
        },
        error: function error(data, _error) {
          console.log(_error);
          $('.spinner').hide();
          self.errorPopup();
        }
      });
    },
    NewOptimisebtnClick: function NewOptimisebtnClick() {
      this.NewOptimiseClick = true;
      $('.inputOptimizeNamr').removeClass('view');
    },
    verclosebutton: function verclosebutton() {
      this.NewOptimiseClick = false;
      $('.inputOptimizeNamr').addClass('view');
    },
    NewOptimisebtntrigger: function NewOptimisebtntrigger() {
      var self = this;
      var postdata = [];
      var dupreportj = self.dupreportj;
      var jobId = window.localStorage.getItem('JobId');
      jobId = jobId.replace('job-id=', '');
      var versionName = self.versionName;
      if (versionName.length === 0) {
        $('.error-msg').show();
        $('#optimname').addClass('error');
        return;
      }
      if (dupreportj.length === 0) {
        dupreportj = self.reportj;
      }
      var newstringer = {
        'job-id': jobId,
        'user-id': window.localStorage.getItem('user'),
        'AnnualSpend': dupreportj.AnnualSpend,
        'asymptote_values': dupreportj.asymptote_values,
        'version-name': versionName
      };
      newstringer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newstringer);
      postdata.push({
        'data': newstringer
      });
      var mydatato = postdata[0];
      mydatato = $.param(mydatato);
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/OptimiseEcosystemOutput',
        data: mydatato,
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          $('.spinner').show();
        },
        complete: function complete() {
          $('.spinner').hide();
          self.OptimisebtnClick();
          self.verclosebutton();
          self.versionName = '';
          self.optimiseDatapopup();
        },
        success: function success(data) {},
        error: function error(data, _error2) {
          console.log(_error2);
          $('.spinner').hide();
          self.errorPopup();
        }
      });
    },
    togglebuttonSelect: function togglebuttonSelect() {
      if ($('.togglebutton input').hasClass('checked') === false) {
        $('.togglebutton input').addClass('checked');
        $('.togglerBoxes').addClass('active');
        this.currenttoggle = this.kpi;
        this.Tkpi = this.kpi;
      } else if ($('.togglebutton input').hasClass('checked')) {
        $('.togglebutton input').removeClass('checked');
        $('.togglerBoxes').removeClass('active');
        this.currenttoggle = 'ROI';
        this.Tkpi = 'ROI';
        this.EcosystemROI = this.reportj.EcosystemROI;
        this.MediaDrivenROI = this.reportj.MediaDrivenROI;
      }
    },
    cexcelHeight: function cexcelHeight() {
      this.excelHeight = this.excelheight + 1;
    },
    resetbtnClick: function resetbtnClick() {
      var err = {
        title: 'Coming Soon',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton',
        onClose: this.resetClose
      };
      this.$refs.simplert.openSimplert(err);
    },
    resetClose: function resetClose() {},
    OptimisebtnClick: function OptimisebtnClick() {
      console.log(this.slideroptions);

      this.slideroptions.sliderStyle[0].backgroundColor = '#444';
      this.slideroptions.bgStyle.backgroundColor = '#444';
      this.slideroptions.piecewiseActiveStyle.backgroundColor = '#444';
      this.slideroptions.processStyle.backgroundColor = '#444';
      this.slideroptions.tooltipStyle.backgroundColor = '#444';
      this.slideroptions.labelActiveStyle.backgroundColor = '#444';
      $('.vue-slider-dot').addClass('graydot');
    },
    optimiseClose: function optimiseClose() {},
    cancelClick: function cancelClick() {
      this.$router.push('/');
    },
    errorPopup: function errorPopup() {
      var err = {
        title: 'It looks like, you have hit an error',
        message: 'Please raise a ticket in yammer group',
        type: 'error',
        customClass: 'error'
      };
      this.$refs.simplert.openSimplert(err);
    },
    optimiseDatapopup: function optimiseDatapopup() {
      var err = {
        title: 'Optimisation will take sometime, check back in few mins',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton'
      };
      this.$refs.simplert.openSimplert(err);
    },
    saveDatapopup: function saveDatapopup() {
      var err = {
        title: 'Data Saved',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton'
      };
      this.$refs.simplert.openSimplert(err);
    },
    savebuttonclick: function savebuttonclick() {
      this.UpdatebtnClick('save');
    },

    updateSlider: function updateSlider(val, event) {
      var newstr = String(val.name);
      newstr = newstr.replace(/\s/gi, '_');
      var currentNum = event.currentTarget.value;
      currentNum = currentNum.replace(/,/gi, '');
      this.$refs['slider' + newstr][0].setValue(currentNum);
    },
    checkslider: function checkslider(val, event) {
      var newstr = String(val.name);
      newstr = newstr.replace(/\s/gi, '_');
      this.dupreportj = this.reportj;
      this.reportj.AnnualSpend[newstr].spend = val.spend;
      this.dupreportj.AnnualSpend[newstr].spend = val.spend;
      this.updateBtnDisable = false;
    },
    handleNetworkClickEvent: function handleNetworkClickEvent(edges, nodes, currentNodeLabel) {
      var self = this;
      var edgearray = self.reportj.edges;
      var nodearray = self.reportj.nodes;

      var idObject = {};
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(edges._data).forEach(function (key1) {
        var outerTo = edges._data[key1].to;
        var outerFrom = edges._data[key1].from;
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(edges._data).forEach(function (key2) {
          var innerTo = edges._data[key2].to;
          var innerFrom = edges._data[key2].from;
          if (innerFrom !== outerFrom && innerTo === outerTo) {
            idObject[edges._data[key2].id] = edges._data[key2];
          }
        });
      });
      var getExistingEdgesArray = [];
      if (self.clickcheck.length > 0 && self.clickcheck.includes(currentNodeLabel)) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(edges._data).forEach(function (index) {
          if (edges._data[index].to > 99 && nodearray.includes(edges._data[index].to)) {
            self.paidmediaCheck.push(edges._data[index]);
          }
          if (edges._data[index].to === currentNodeLabel) {
            getExistingEdgesArray.push(edges._data[index]);
          }
        });

        var deleteNodesOnClick = getExistingEdgesArray.map(function (e, i) {
          var getId = e.id;

          if ((e.from !== 0 || e.to !== 0) && e.to === currentNodeLabel) {
            edges.remove(e.id);
          }
          if (idObject[getId]) {
            var cnodeChild = [];
            var othernodesChild = [];
            var diffNode = [];
            edgearray.forEach(function (edgekey) {
              if (edgekey.to === currentNodeLabel) {
                cnodeChild.push(edgekey.from);
              }
            });

            edgearray.forEach(function (edgekey) {
              if (self.clickcheck.includes(edgekey.to) && edgekey.to !== 0) {
                if (edgekey.to !== currentNodeLabel && edgekey.from > 99) {
                  othernodesChild.push(edgekey.from);
                }
              }
            });

            diffNode = cnodeChild.filter(function (x) {
              return othernodesChild.indexOf(x) < 0;
            });

            diffNode.forEach(function (remkey) {
              nodes.remove(remkey);
            });
          }

          return true;
        });
        var nodelabelindex = self.clickcheck.indexOf(currentNodeLabel);
        self.clickcheck.splice(nodelabelindex, 1);
        if (deleteNodesOnClick.includes(true)) {
          return false;
        }
      }

      edgearray.forEach(function (val, index) {
        if (val.to === currentNodeLabel) {
          var valin = val.from;

          nodearray.find(function (element) {
            if (element.id === valin) {
              if (nodes._getItem(element.id) === null) {
                nodes.add(element);
                if (element.id > 99) {
                  self.paidmediaCheck.push(element.id);
                }
              }
            }
          });
          window.network.stabilize();

          if (edges._getItem(val.id) === null) {
            edges.add(val);
          }
          self.edges.push(val);

          window.network.redraw();
          return;
        }
      });
      if (self.clickcheck.includes(currentNodeLabel) === false) {
        self.clickcheck.push(currentNodeLabel);
      }
    },
    handleHoverEdgeEvent: function handleHoverEdgeEvent(params, currentEdgeValue) {
      this.$refs.tooltip.style.x = params.pointer.DOM.x;
      this.$refs.tooltip.style.y = params.pointer.DOM.y;
      $('.tooltip2').css({
        'top': params.pointer.DOM.y,
        'left': params.pointer.DOM.x
      });
      $('.tooltip2').text(currentEdgeValue);
      $('.tooltip2').css({ 'opacity': '1' });
    },
    handleHoverNodeEvent: function handleHoverNodeEvent(params, currentEdgeValue, currentnodename) {
      this.$refs.tooltip.style.x = params.pointer.DOM.x + 15;
      this.$refs.tooltip.style.y = params.pointer.DOM.y + 15;
      $('.tooltip2').css({
        'top': params.pointer.DOM.y + 15,
        'left': params.pointer.DOM.x + 15
      });
      $('.tooltip2').text(currentnodename + ' : ' + currentEdgeValue);
      this.reportj.nodes.find(function (element) {
        if (element.label === currentnodename) {
          $('.tooltip2').text(currentnodename + ' : ' + Math.floor(element.value));
        }
      });
      $('.tooltip2').css({ 'opacity': '1' });
    },
    handleNodeEdgeBlurEvent: function handleNodeEdgeBlurEvent() {
      $('.tooltip2').css({ 'opacity': '0' });
      return;
    },
    updateHotSetting: function updateHotSetting(params, nodesDataset) {
      var self = this;
      var selectednode = nodesDataset.get(params.nodes)[0].label;
      var newstr = String(selectednode);
      newstr = newstr.replace(/\s/gi, '_');
      self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[newstr].nest_name + ' %'];
      self.hotSettings.data = self.reportj.asymptote_values[newstr].channel;
      self.currentNest = self.reportj.asymptote_values[newstr];
      self.currentnest_name = self.reportj.asymptote_values[newstr].nest_name;
    },
    onUpdatechangeSlidertheame: function onUpdatechangeSlidertheame() {
      console.log(this.slideroptions);

      this.slideroptions.sliderStyle[0].backgroundColor = '#ce785b';
      this.slideroptions.bgStyle.backgroundColor = '#ce785b';
      this.slideroptions.piecewiseActiveStyle.backgroundColor = '#ce785b';
      this.slideroptions.processStyle.backgroundColor = '#ce785b';
      this.slideroptions.tooltipStyle.backgroundColor = '#ce785b';
      this.slideroptions.labelActiveStyle.backgroundColor = '#ce785b';
      $('.vue-slider-dot').removeClass('graydot');
    },
    UpdatebtnClick: function UpdatebtnClick(saveparm) {
      var parm = saveparm;
      var self = this;
      var saveParm = false;
      var postdata = [];
      var mode = '';
      var dupreportj = self.dupreportj;
      var jobId = window.localStorage.getItem('JobId');
      jobId = jobId.replace('job-id=', '');
      if (parm === 'save') {
        saveParm = true;
        mode = 'save';
        this.onUpdatechangeSlidertheame();
      } else if (parm === 'optimise') {
        saveParm = false;
        mode = 'optimise';
      } else if (parm === 'update') {
        saveParm = false;
        mode = 'update';
        self.enableCompare = true;
        this.onUpdatechangeSlidertheame();
      }
      if (dupreportj.length === 0) {
        dupreportj = self.reportj;
      }
      var newstringer = {
        'job-id': jobId,
        'user-id': window.localStorage.getItem('user'),
        'AnnualSpend': dupreportj.AnnualSpend,
        'asymptote_values': dupreportj.asymptote_values,
        'save-output': saveParm,
        'mode': mode,
        'version-id': self.versions[self.$refs.versionsCombo.value].version_id
      };
      newstringer = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newstringer);
      postdata.push({
        'data': newstringer
      });
      var mydatato = postdata[0];
      mydatato = $.param(mydatato);
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/UpdateEcosystemOutput',
        data: mydatato,
        async: true,
        contentType: 'application/json',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function beforeSend() {
          $('.spinner').show();
          if (mode === 'update') {
            self.loadingtext = 'applying new values...';
            setTimeout(function () {
              self.loadingtext = 'adjusting calculations...';
            }, 3000);
            setTimeout(function () {
              self.loadingtext = 'almost done!';
            }, 6000);
          } else if (mode === 'save') {
            self.loadingtext = 'adjusting input template...';
            setTimeout(function () {
              self.loadingtext = 'saving values...';
            }, 3000);
            setTimeout(function () {
              self.loadingtext = 'almost done!';
            }, 4500);
          } else if (mode === 'optimise') {
            self.loadingtext = 'calculating optimal spend...';
            setTimeout(function () {
              self.loadingtext = 'adjusting calculations...';
            }, 3000);
            setTimeout(function () {
              self.loadingtext = 'almost done!';
            }, 4500);
          }
        },
        complete: function complete() {
          $('.spinner').hide();
          if (saveParm === true) {
            self.saveDatapopup();
          }
          self.cexcelHeight();
        },
        success: function success(data) {
          data = data['output'];
          try {
            data = JSON.parse(data);

            self.reportj = data;
            self.sliderinputval = self.reportj.AnnualSpend;
            self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

            self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            self.EcosystemROI = self.reportj.EcosystemROI;
            self.MediaDrivenROI = self.reportj.MediaDrivenROI;

            var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(self.reportj.AnnualSpend).map(function (key) {
              return [self.reportj.AnnualSpend[key]];
            });
            if (self.enableCompare === true) {
              self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per;
              self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per;
              self.CompareTotalSales = self.reportj.compare.TotalSales.per;
              self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per;
              self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect;
              self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect;
              self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect;
              self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect;
              $('.highlitboxes span').css({ 'top': '-17px' });
              $('.highlitboxes label').css({ 'display': 'block' });
            }
            self.clickcheck = [];
            self.nodes = [];
            self.edges = [];
            var nodes = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.nodes);
            var edges = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.edges);
            self.reportj.nodes.forEach(function (value, index) {
              if (value.id <= 99 && value.id > 0) {
                self.reportj.edges.forEach(function (evalue, eindex) {
                  if (value.id === evalue.from) {
                    if (evalue.from < 99 && evalue.to === 0) {
                      self.nodes.push(value);
                      nodes.add(value);
                    }
                  }
                });
              } else if (value.id === 0) {
                self.nodes.push(value);
                nodes.add(value);
              } else {
                self.addnodes.push(value);
              }
            });
            self.reportj.edges.forEach(function (value, index) {
              if (value.to === 0) {
                self.edges.push(value);
                edges.add(value);
              } else {
                self.addedges.push(value);
              }
            });
            self.container = document.getElementById('mynetwork');
            var newdata = {
              nodes: nodes,
              edges: edges
            };
            self.clickcheck = [];
            window.network.setData(newdata);
            window.network = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.Network(self.container, newdata, self.options);
            window.network.on('doubleClick', function (params) {
              params.event = '[original event]';
              if (this.getNodeAt(params.pointer.DOM) === undefined) {
                return false;
              }

              var nodesDataset = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.nodes);
              var currentNodeLabel = nodesDataset.get(params.nodes)[0].id;
              self.updateHotSetting(params, nodesDataset);
              if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
                return false;
              }
              self.handleNetworkClickEvent(edges, nodes, currentNodeLabel);
            });
            window.network.on('hoverEdge', function (params, event) {
              params.event = '[original event]';
              var currentEdgeValue = this.body.data.edges.get(params.edge).title;
              self.handleHoverEdgeEvent(params, currentEdgeValue);
            });
            window.network.on('blurEdge', function (params, event) {
              params.event = '[original event]';
              self.handleNodeEdgeBlurEvent();
            });
            var changeCursor = function changeCursor(newCursorStyle) {
              var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0];
              networkCanvas.style.cursor = newCursorStyle;
            };
            window.network.on('hoverNode', function (params, event) {
              params.event = '[original event]';
              changeCursor('pointer');
              var currentEdgeValue = this.body.data.nodes.get(params.node).value;
              var currentnodename = this.body.data.nodes.get(params.node).label;
              self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename);
            });
            window.network.on('blurNode', function (params, event) {
              params.event = '[original event]';
              self.handleNodeEdgeBlurEvent();
            });
            self.TotalSpentarr = result;
            self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %'];
            self.currentNest = self.reportj.asymptote_values[self.kpi];
            self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name;
            self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel;
            self.calculatetotalspent(result);
            self.country = self.reportj.country;
            self.modelname = self.reportj.name;
            self.category = self.reportj.category;
          } catch (err) {
            console.log(err);
            $('.spinner').hide();
            self.errorPopup();
          }
          return data;
        },
        error: function error(data, _error3) {
          console.log(_error3);
          $('.spinner').hide();
          self.errorPopup();
        }
      });
    },
    calculatetotalspent: function calculatetotalspent(anualspentarray) {
      var self = this;
      var totspent = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(anualspentarray).forEach(function (val, index) {
        totspent = totspent + val[0].spend;
      });

      totspent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(totspent);
      totspent = totspent.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      self.TotalSpent = totspent;
      return totspent;
    }
  },
  mounted: function mounted() {
    var self = this;
    var jobId = window.localStorage.getItem('JobId');
    var versionid = window.localStorage.getItem('JobVersion');
    jobId = jobId.replace('job-id=', '');
    __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
      type: 'POST',
      url: window.localStorage.getItem('ApiURL') + '/getecosystemoutput',
      async: true,
      contentType: 'application/json',
      data: { 'job-id': jobId, 'user-id': window.localStorage.getItem('user'), 'nest': 'all', 'version-id': versionid },
      headers: {
        'x-api-key': window.localStorage.getItem('XpiKey')
      },
      beforeSend: function beforeSend() {
        $('.spinner').show();
        self.loadingtext = 'applying new values...';
        setTimeout(function () {
          self.loadingtext = 'adjusting calculations...';
        }, 200);
        setTimeout(function () {
          self.loadingtext = 'almost done!';
        }, 300);
      },
      complete: function complete() {
        console.log(self);

        $('.spinner').hide();
      },
      success: function success(data) {
        data = data['output'];

        try {
          self.reportj = data;
          self.sliderinputval = self.reportj.AnnualSpend;
          self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
          self.country = self.reportj.country;
          self.modelname = self.reportj.name;
          self.category = self.reportj.category;

          self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
          self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
          self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
          self.EcosystemROI = self.reportj.EcosystemROI;
          self.MediaDrivenROI = self.reportj.MediaDrivenROI;
          self.kpi = self.reportj.KPI;
          self.Tkpi = self.reportj.KPI;
          self.currenttoggle = self.reportj.KPI;
          self.versions = self.reportj.versions;
          if (self.versions[0].version_status !== 'completed') {
            self.modelVesrionSelect = 1;
          } else if (self.versions[0].version_status === 'completed') {
            self.modelVesrionSelect = 0;
          }
          self.currencySymbol = self.reportj.currency_symbol;
          if (self.reportj.KPI === ' ' || self.reportj.KPI === undefined) {
            self.kpi = 'Sales';
            self.Tkpi = 'Sales';
          }
          if (self.reportj.compare !== undefined) {
            self.enableCompare = true;
          } else if (self.reportj.compare === undefined) {
            self.enableCompare = false;
          }
          if (self.enableCompare === true) {
            self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per;
            self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per;
            self.CompareTotalSales = self.reportj.compare.TotalSales.per;
            self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per;
            self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect;
            self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect;
            self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect;
            self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect;
            $('.highlitboxes span').css({ 'top': '-17px' });
            $('.highlitboxes label').css({ 'display': 'block' });
          } else if (self.enableCompare === false) {
            $('.highlitboxes span').css({ 'top': '-25px' });
            $('.highlitboxes label').css({ 'display': 'none' });
          }

          var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(self.reportj.AnnualSpend).map(function (key, index) {
            self.sliderLength = index;
            return [self.reportj.AnnualSpend[key]];
          });

          self.reportj.edges.forEach(function (value, index) {});
          self.reportj.nodes.forEach(function (value, index) {
            if (value.id <= 99 && value.id > 0) {
              self.reportj.edges.forEach(function (evalue, eindex) {
                if (value.id === evalue.from) {
                  if (evalue.from < 99 && evalue.to === 0) {
                    self.nodes.push(value);
                    nodes.add(value);
                  }
                }
              });
            } else if (value.id === 0) {
              self.nodes.push(value);
              nodes.add(value);
            } else {
              self.addnodes.push(value);
            }
          });
          self.reportj.edges.forEach(function (value, index) {
            if (value.to === 0) {
              self.edges.push(value);
              edges.add(value);
            } else {
              self.addedges.push(value);
            }
          });
          self.TotalSpentarr = result;
          self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %'];
          self.currentNest = self.reportj.asymptote_values[self.kpi];
          self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name;
          self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel;
          self.calculatetotalspent(result);

          if (data.length === 0) {
            return;
          }
          self.cexcelHeight();
        } catch (err) {
          console.log(err);
          $('.spinner').hide();
          self.errorPopup();
        }
        return data;
      },
      error: function error(data, _error4) {
        console.log(_error4);
        $('.spinner').hide();
        self.errorPopup();
      }
    });
    var nodes = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(this.nodes);
    var edges = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(this.edges);
    this.container = document.getElementById('mynetwork');
    var data = {
      nodes: nodes,
      edges: edges
    };
    window.network = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.Network(this.container, data, this.options);
    var changeCursor = function changeCursor(newCursorStyle) {
      var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0];
      networkCanvas.style.cursor = newCursorStyle;
    };
    var clusterOptionsByData = {
      joinCondition: function joinCondition(nodeOptions) {
        return nodeOptions.cid === '2';
      },
      clusterNodeProperties: { id: 2, borderWidth: 3, shape: 'dot', font: { size: 30 }, allowSingleNodeCluster: true }
    };

    window.network.cluster(clusterOptionsByData);

    window.network.on('doubleClick', function (params) {
      params.event = '[original event]';
      if (this.getNodeAt(params.pointer.DOM) === undefined) {
        return false;
      }
      var nodesDataset = new __WEBPACK_IMPORTED_MODULE_4_vis___default.a.DataSet(self.nodes);
      var currentNodeLabel = nodesDataset.get(params.nodes)[0].id;
      self.updateHotSetting(params, nodesDataset);
      if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
        return false;
      }
      self.handleNetworkClickEvent(edges, nodes, currentNodeLabel);
    });
    window.network.on('hoverEdge', function (params, event) {
      params.event = '[original event]';
      var currentEdgeValue = this.body.data.edges.get(params.edge).title;
      self.handleHoverEdgeEvent(params, currentEdgeValue);
    });
    window.network.on('blurEdge', function (params, event) {
      params.event = '[original event]';
      self.handleNodeEdgeBlurEvent();
    });
    window.network.on('hoverNode', function (params, event) {
      params.event = '[original event]';
      changeCursor('pointer');
      var currentEdgeValue = this.body.data.nodes.get(params.node).value;
      var currentnodename = this.body.data.nodes.get(params.node).label;
      self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename);
      return;
    });
    window.network.on('blurNode', function (params, event) {
      params.event = '[original event]';
      self.handleNodeEdgeBlurEvent();
    });
  }
});

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 27,
	"./af.js": 27,
	"./ar": 34,
	"./ar-dz": 28,
	"./ar-dz.js": 28,
	"./ar-kw": 29,
	"./ar-kw.js": 29,
	"./ar-ly": 30,
	"./ar-ly.js": 30,
	"./ar-ma": 31,
	"./ar-ma.js": 31,
	"./ar-sa": 32,
	"./ar-sa.js": 32,
	"./ar-tn": 33,
	"./ar-tn.js": 33,
	"./ar.js": 34,
	"./az": 35,
	"./az.js": 35,
	"./be": 36,
	"./be.js": 36,
	"./bg": 37,
	"./bg.js": 37,
	"./bm": 38,
	"./bm.js": 38,
	"./bn": 39,
	"./bn.js": 39,
	"./bo": 40,
	"./bo.js": 40,
	"./br": 41,
	"./br.js": 41,
	"./bs": 42,
	"./bs.js": 42,
	"./ca": 43,
	"./ca.js": 43,
	"./cs": 44,
	"./cs.js": 44,
	"./cv": 45,
	"./cv.js": 45,
	"./cy": 46,
	"./cy.js": 46,
	"./da": 47,
	"./da.js": 47,
	"./de": 50,
	"./de-at": 48,
	"./de-at.js": 48,
	"./de-ch": 49,
	"./de-ch.js": 49,
	"./de.js": 50,
	"./dv": 51,
	"./dv.js": 51,
	"./el": 52,
	"./el.js": 52,
	"./en-au": 53,
	"./en-au.js": 53,
	"./en-ca": 54,
	"./en-ca.js": 54,
	"./en-gb": 55,
	"./en-gb.js": 55,
	"./en-ie": 56,
	"./en-ie.js": 56,
	"./en-nz": 57,
	"./en-nz.js": 57,
	"./eo": 58,
	"./eo.js": 58,
	"./es": 61,
	"./es-do": 59,
	"./es-do.js": 59,
	"./es-us": 60,
	"./es-us.js": 60,
	"./es.js": 61,
	"./et": 62,
	"./et.js": 62,
	"./eu": 63,
	"./eu.js": 63,
	"./fa": 64,
	"./fa.js": 64,
	"./fi": 65,
	"./fi.js": 65,
	"./fo": 66,
	"./fo.js": 66,
	"./fr": 69,
	"./fr-ca": 67,
	"./fr-ca.js": 67,
	"./fr-ch": 68,
	"./fr-ch.js": 68,
	"./fr.js": 69,
	"./fy": 70,
	"./fy.js": 70,
	"./gd": 71,
	"./gd.js": 71,
	"./gl": 72,
	"./gl.js": 72,
	"./gom-latn": 73,
	"./gom-latn.js": 73,
	"./gu": 74,
	"./gu.js": 74,
	"./he": 75,
	"./he.js": 75,
	"./hi": 76,
	"./hi.js": 76,
	"./hr": 77,
	"./hr.js": 77,
	"./hu": 78,
	"./hu.js": 78,
	"./hy-am": 79,
	"./hy-am.js": 79,
	"./id": 80,
	"./id.js": 80,
	"./is": 81,
	"./is.js": 81,
	"./it": 82,
	"./it.js": 82,
	"./ja": 83,
	"./ja.js": 83,
	"./jv": 84,
	"./jv.js": 84,
	"./ka": 85,
	"./ka.js": 85,
	"./kk": 86,
	"./kk.js": 86,
	"./km": 87,
	"./km.js": 87,
	"./kn": 88,
	"./kn.js": 88,
	"./ko": 89,
	"./ko.js": 89,
	"./ky": 90,
	"./ky.js": 90,
	"./lb": 91,
	"./lb.js": 91,
	"./lo": 92,
	"./lo.js": 92,
	"./lt": 93,
	"./lt.js": 93,
	"./lv": 94,
	"./lv.js": 94,
	"./me": 95,
	"./me.js": 95,
	"./mi": 96,
	"./mi.js": 96,
	"./mk": 97,
	"./mk.js": 97,
	"./ml": 98,
	"./ml.js": 98,
	"./mr": 99,
	"./mr.js": 99,
	"./ms": 101,
	"./ms-my": 100,
	"./ms-my.js": 100,
	"./ms.js": 101,
	"./mt": 102,
	"./mt.js": 102,
	"./my": 103,
	"./my.js": 103,
	"./nb": 104,
	"./nb.js": 104,
	"./ne": 105,
	"./ne.js": 105,
	"./nl": 107,
	"./nl-be": 106,
	"./nl-be.js": 106,
	"./nl.js": 107,
	"./nn": 108,
	"./nn.js": 108,
	"./pa-in": 109,
	"./pa-in.js": 109,
	"./pl": 110,
	"./pl.js": 110,
	"./pt": 112,
	"./pt-br": 111,
	"./pt-br.js": 111,
	"./pt.js": 112,
	"./ro": 113,
	"./ro.js": 113,
	"./ru": 114,
	"./ru.js": 114,
	"./sd": 115,
	"./sd.js": 115,
	"./se": 116,
	"./se.js": 116,
	"./si": 117,
	"./si.js": 117,
	"./sk": 118,
	"./sk.js": 118,
	"./sl": 119,
	"./sl.js": 119,
	"./sq": 120,
	"./sq.js": 120,
	"./sr": 122,
	"./sr-cyrl": 121,
	"./sr-cyrl.js": 121,
	"./sr.js": 122,
	"./ss": 123,
	"./ss.js": 123,
	"./sv": 124,
	"./sv.js": 124,
	"./sw": 125,
	"./sw.js": 125,
	"./ta": 126,
	"./ta.js": 126,
	"./te": 127,
	"./te.js": 127,
	"./tet": 128,
	"./tet.js": 128,
	"./th": 129,
	"./th.js": 129,
	"./tl-ph": 130,
	"./tl-ph.js": 130,
	"./tlh": 131,
	"./tlh.js": 131,
	"./tr": 132,
	"./tr.js": 132,
	"./tzl": 133,
	"./tzl.js": 133,
	"./tzm": 135,
	"./tzm-latn": 134,
	"./tzm-latn.js": 134,
	"./tzm.js": 135,
	"./uk": 136,
	"./uk.js": 136,
	"./ur": 137,
	"./ur.js": 137,
	"./uz": 139,
	"./uz-latn": 138,
	"./uz-latn.js": 138,
	"./uz.js": 139,
	"./vi": 140,
	"./vi.js": 140,
	"./x-pseudo": 141,
	"./x-pseudo.js": 141,
	"./yo": 142,
	"./yo.js": 142,
	"./zh-cn": 143,
	"./zh-cn.js": 143,
	"./zh-hk": 144,
	"./zh-hk.js": 144,
	"./zh-tw": 145,
	"./zh-tw.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)
__webpack_require__(210)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  "data-v-533a00c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  "data-v-56c02b50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)
__webpack_require__(219)
__webpack_require__(220)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table logincontainer"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "loadingtext"
  }, [_vm._v(_vm._s(_vm.loadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])]), _vm._v(" "), _c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logina-logo",
    attrs: {
      "src": "/static/img/velocity_login_logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4"
  }, [_c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Username",
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginforget"
  }, [_vm._v("Forgot username? "), _c('a', {
    attrs: {
      "href": "https://www.yammer.com/dentsuaegis.com/#/threads/inGroup?type=in_group&feedId=14264485&view=all",
      "target": "blank"
    }
  }, [_vm._v("contact in yammer")])])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-three"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      8. Paid Media annual budget\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "paidMediaId",
    attrs: {
      "root": _vm.paidMediaId,
      "settings": _vm.paidMedia
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step3'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step3']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": this.root
    }
  })
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ({
      height: _vm.ModalHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "steps-nav-wrapper"
  }, [_c('div', {
    staticClass: "steps-nav"
  }, [_c('span', {
    staticClass: "steps-count",
    class: {
      'active': (_vm.step == 1)
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "steps-count",
    class: {
      'active': (_vm.step == 2)
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "steps-count",
    class: {
      'active': (_vm.step == 3)
    }
  }, [_vm._v("3")]), _vm._v(" "), (_vm.modelType != 'view') ? _c('span', {
    staticClass: "steps-count",
    class: {
      'active': (_vm.step == 4)
    }
  }, [_vm._v("4")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "steps-heading clearfix"
  }, [(_vm.modelType == 'create') ? _c('span', [_vm._v("Create Model")]) : (_vm.modelType == 'view') ? _c('span', [_vm._v("Model Configuration Details : " + _vm._s(_vm.ViewModel.name))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "steps-content"
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('keep-alive', [_c(_vm.ActiveComponent, {
    tag: "component",
    attrs: {
      "inputData": _vm.Input,
      "createdObject": _vm.CreatedModel,
      "viewObject": _vm.ViewModel,
      "modelType": _vm.modelType,
      "validate": _vm.Validate
    },
    on: {
      "stepValidate": function($event) {
        _vm.stepsValidations(_vm.step)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fluid-container text-right"
  }, [(_vm.step > 1) ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("Back")])]) : _vm._e(), _vm._v(" "), (_vm.step < _vm.steps) ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next")])]) : _vm._e(), _vm._v(" "), (_vm.step == _vm.steps && _vm.modelType != 'view') ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.createModel
    }
  }, [_vm._v("Create Model")])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && _vm.modelType == 'view') ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.$router.push('/report')
      }
    }
  }, [_vm._v("View Report")])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary create-model-btn",
    on: {
      "click": function($event) {
        _vm.showModel('create')
      }
    }
  }, [_vm._v("\n    Create New\n  ")]), _vm._v(" "), (_vm.showModal) ? _c('CreateModel', {
    attrs: {
      "modelType": _vm.modelType
    },
    on: {
      "close": function($event) {
        _vm.closeModal()
      },
      "openModal": _vm.ModelCreated
    }
  }) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "model-history"
  }, [_vm._m(1), _vm._v(" "), _c('demo-grid', {
    attrs: {
      "data": _vm.gridData,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery,
      "pagination": _vm.pagination,
      "sortKeys": _vm.sortKeys
    },
    on: {
      "pageChange": function($event) {
        _vm.pageChange($event, 'pagination')
      },
      "showModel": _vm.showModel
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spinner",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "loadingtext"
  }, [_vm._v(_vm._s(_vm.loadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "steps-heading clearfix"
  }, [_c('span', [_vm._v("Model Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('strong', [_vm._v("Existing Models")])])
}]}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key, indexOf) {
    return _c('th', {
      key: indexOf,
      class: {
        active: _vm.sortKey == key && _vm.isSortKey(key), pointer: _vm.isSortKey(key)
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm._f("prettifyCamelCase")(key)) + "\n          "), (_vm.isSortKey(key)) ? _c('span', {
      staticClass: "arrow",
      class: (_vm.sortOrders[key] > 0 || _vm.sortOrders[key] === undefined) ? 'asc' : 'dsc'
    }) : _vm._e()])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry, indexOf) {
    return _c('tr', {
      key: indexOf
    }, _vm._l((_vm.columns), function(key) {
      return _c('td', {
        key: entry[key],
        attrs: {
          "value": key
        }
      }, [(key === 'Access Report') ? _c('button', {
        staticClass: "btn btn-primary",
        attrs: {
          "tabindex": "-1"
        },
        on: {
          "click": function($event) {
            _vm.setJobId(entry)
          }
        }
      }, [_vm._v("View Report")]) : (key === 'Name') ? _c('div', {
        staticClass: "model-name"
      }, [_c('span', [_vm._v(_vm._s(entry[key]))]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-secondary view-btn",
        attrs: {
          "disabled": _vm.viewButton,
          "tabindex": "-1",
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.openSetting(entry, $event)
          }
        }
      }, [_c('svg', {
        attrs: {
          "width": "20",
          "height": "20",
          "viewBox": "0 -3 35 35",
          "fill": "#ffffff"
        }
      }, [_c('g', {
        attrs: {
          "transform": "scale(0.03125 0.03125)"
        }
      }, [_c('path', {
        attrs: {
          "d": "M933.79 610.25c-53.726-93.054-21.416-212.304 72.152-266.488l-100.626-174.292c-28.75 16.854-62.176 26.518-97.846 26.518-107.536 0-194.708-87.746-194.708-195.99h-201.258c0.266 33.41-8.074 67.282-25.958 98.252-53.724 93.056-173.156 124.702-266.862 70.758l-100.624 174.292c28.97 16.472 54.050 40.588 71.886 71.478 53.638 92.908 21.512 211.92-71.708 266.224l100.626 174.292c28.65-16.696 61.916-26.254 97.4-26.254 107.196 0 194.144 87.192 194.7 194.958h201.254c-0.086-33.074 8.272-66.57 25.966-97.218 53.636-92.906 172.776-124.594 266.414-71.012l100.626-174.29c-28.78-16.466-53.692-40.498-71.434-71.228zM512 719.332c-114.508 0-207.336-92.824-207.336-207.334 0-114.508 92.826-207.334 207.336-207.334 114.508 0 207.332 92.826 207.332 207.334-0.002 114.51-92.824 207.334-207.332 207.334z"
        }
      })])])])]) : _c('span', [_vm._v(_vm._s(entry[key]))])])
    }))
  }))]), _vm._v(" "), _c('div', {
    ref: "settingPopup",
    staticClass: "settingPopup",
    style: ({
      top: '10px',
      right: '10px'
    })
  }, [_c('a', {
    staticClass: "closebtn",
    on: {
      "click": _vm.settingPopupClose
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btnDelete",
    on: {
      "click": function($event) {
        _vm.removeSelectedJobAlert(_vm.currententPointData, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btnViewModel",
    on: {
      "click": function($event) {
        _vm.$emit('showModel', 'view', _vm.currentJobView), _vm.settingPopupClose()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])]), _vm._v(" "), (_vm.shouldShowPagination) ? _c('nav', [_c('div', {
    staticClass: "ui centered pagination menu"
  }, [_c('button', {
    staticClass: "icon item",
    class: {
      disabled: _vm.pagination.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.pageClicked(_vm.pagination.currentPage - 1)
      }
    }
  }, [_vm._v("Prev\n        "), _c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((_vm.pageLinks), function(page) {
    return _c('button', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.isActive(page), disabled: page === '...'
      },
      on: {
        "click": function($event) {
          _vm.pageClicked(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page) + "\n      ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "icon item",
    class: {
      disabled: _vm.pagination.currentPage === this.pagination.totalPages
    },
    on: {
      "click": function($event) {
        _vm.pageClicked(_vm.pagination.currentPage + 1)
      }
    }
  }, [_vm._v("Next\n        "), _c('i', {
    staticClass: "right chevron icon"
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-two"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      7. Total " + _vm._s(_vm.createdObject.KPI) + " per week\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "salesTableId",
    attrs: {
      "root": _vm.salesTableId,
      "settings": _vm.weekSales
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createdObject.base_sales_flag),
      expression: "createdObject.base_sales_flag"
    }],
    attrs: {
      "id": "Historic",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.createdObject.base_sales_flag ? 'checked' : '',
      "checked": Array.isArray(_vm.createdObject.base_sales_flag) ? _vm._i(_vm.createdObject.base_sales_flag, null) > -1 : (_vm.createdObject.base_sales_flag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createdObject.base_sales_flag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createdObject, "base_sales_flag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createdObject, "base_sales_flag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createdObject, "base_sales_flag", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Historic"
    }
  }, [_vm._v("Historic Sales Data")])])]), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step2'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step2']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown messages-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.messages)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.messages)) + " message(s)")]), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.messages.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown notifications-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.notifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.notifications)) + " notification(s)")]), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs user-name"
  }, [_vm._v(_vm._s(_vm.demo.displayName))]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Layer_1",
      "enable-background": "new 0 0 48 48",
      "viewBox": "0 0 48 48",
      "width": "33px",
      "height": "33px",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace",
      "xml:space": "preserve",
      "version": "1.1"
    }
  }, [_c('g', [_c('g', [_c('circle', {
    attrs: {
      "fill": "#ffffff",
      "cx": "24",
      "cy": "18.796",
      "r": "5.084"
    }
  }), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M 30.943 25.688 H 17.056 c -0.904 0 -1.638 0.733 -1.638 1.638 v 10.337 c 2.501 1.554 5.443 2.467 8.605 2.467 c 3.142 0 6.066 -0.902 8.559 -2.439 V 27.326 C 32.582 26.422 31.848 25.688 30.943 25.688 Z"
    }
  })]), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M 24 0 C 10.745 0 0 10.745 0 24 s 10.745 24 24 24 s 24 -10.745 24 -24 S 37.255 0 24 0 Z M 24.029 43.844 c -11.023 0 -19.959 -8.936 -19.959 -19.959 S 13.006 3.926 24.029 3.926 s 19.959 8.936 19.959 19.959 S 35.052 43.844 24.029 43.844 Z"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu usermenu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logoff")])])])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": "https://www.vizeum.com/",
      "target": "blank"
    }
  }, [_vm._v("vizeum")]), _vm._v(".")]), _vm._v(" All rights reserved.\n    ")]), _vm._v(" "), _c('simplert', {
    ref: "confirmbox",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "/static/img/logo.svg",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h4', [_vm._v("\n                          Support Team\n                          "), _c('small', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5 mins")])]), _vm._v(" "), _c('p', [_vm._v("Why not consider this a test message?")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n                          Design some buttons\n                          "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
}]}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-four"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('label', [_vm._v("\n        9. CCS Reach & Segment Data (optional)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 pull-right text-right segment-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "type"
    },
    on: {
      "click": _vm.addSegment
    }
  }, [_vm._v("Add Segment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.CSSRich.columns.length < 3,
      "type": "type"
    },
    on: {
      "click": _vm.deleteSegment
    }
  }, [_vm._v("Delete Segment")])])]), _vm._v(" "), _c('HotTable', {
    ref: "CSSRichId",
    attrs: {
      "root": _vm.CSSRichId,
      "settings": _vm.CSSRich
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      10. CCS Size\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "CSSSizeId",
    attrs: {
      "root": _vm.CSSSizeId,
      "settings": _vm.CSSSize
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step4'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step4']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-one"
  }, [_c('ol', [_c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.createdObject.name == '' && !_vm.validate['step1'])
    },
    attrs: {
      "autofocus": ""
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelName),
      expression: "modelName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "disabled": _vm.modelType === 'view'
    },
    domProps: {
      "value": (_vm.modelName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.modelName = $event.target.value
      }, function($event) {
        _vm.createdObject.name = _vm.modelName
      }]
    }
  }), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v("(e.g. AB inBev | UK | Sales Ecosystem | optimised version)")]), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])])]), _vm._v(" "), _c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.createdObject.country == '' && !_vm.validate['step1'])
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCountry),
      expression: "selectedCountry"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "country",
      "disabled": _vm.modelType === 'view'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.countryChanged($event.target.value)
      }]
    }
  }, [(_vm.modelType === 'view') ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.viewObject.country))]) : _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": false
    }
  }, [_vm._v("Select Country")]), _vm._v(" "), _vm._l((_vm.inputData), function(country) {
    return _c('option', {
      domProps: {
        "value": country.Country
      }
    }, [_vm._v(_vm._s(country.Country))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])]), _vm._v(" "), (_vm.selectedCountry.length !== 0) ? _c('div', {
    staticClass: "SelectedCurrency"
  }, [_vm._v("The Default Currency is " + _vm._s(_vm.SelectedCurrency) + " ")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.createdObject.market == '' && !_vm.validate['step1'])
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "category",
      "disabled": _vm.modelType === 'view'
    },
    on: {
      "change": function($event) {
        _vm.categoryChanged($event.target.value)
      }
    }
  }, [(_vm.modelType === 'view') ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.viewObject.category))]) : _c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": false
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _vm._l((_vm.SelectedCategories), function(category) {
    return _c('option', {
      model: {
        value: (category.Category),
        callback: function($$v) {
          _vm.$set(category, "Category", $$v)
        },
        expression: "category.Category"
      }
    }, [_vm._v(_vm._s(category.Category))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])])]), _vm._v(" "), _c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.createdObject.KPI == '' && !_vm.validate['step1'])
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "KPI"
    }
  }, [_vm._v("KPI")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelKPI),
      expression: "modelKPI"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "KPI",
      "disabled": _vm.modelType === 'view'
    },
    domProps: {
      "value": (_vm.modelKPI)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.modelKPI = $event.target.value
      }, function($event) {
        _vm.createdObject.KPI = _vm.modelKPI
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])])]), _vm._v(" "), _c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.createdObject.nests.length < 2 && !_vm.validate['step1'])
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "earned-media"
    }
  }, [_vm._v("Owned/Earned Media")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.SelectedEarnedMedia,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "max": 10,
      "searchable": false,
      "placeholder": "Add More",
      "disabled": _vm.modelType === 'view'
    },
    on: {
      "select": _vm.GetEarnedMedia,
      "remove": _vm.removeEarnedMedia
    },
    model: {
      value: (_vm.EarnedMediaValue),
      callback: function($$v) {
        _vm.EarnedMediaValue = $$v
      },
      expression: "EarnedMediaValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "form-group",
    class: {
      'invalid-field': (_vm.annualSpend['Channels'].length == 0 && !_vm.validate['step1'])
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "earned-media"
    }
  }, [_vm._v("Paid Media")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.SelectedPaidMedia,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "max": 10,
      "searchable": false,
      "placeholder": "Add More",
      "disabled": _vm.modelType === 'view'
    },
    on: {
      "select": _vm.GetPaidMedia,
      "remove": _vm.removePaidMedia
    },
    model: {
      value: (_vm.PaidMediaValue),
      callback: function($$v) {
        _vm.PaidMediaValue = $$v
      },
      expression: "PaidMediaValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("This is a required field.")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "loadingtext"
  }, [_vm._v(_vm._s(_vm.loadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }, [_vm._v("Loading...")])]), _vm._v(" "), _c('div', {
    staticClass: "togglebutton clearfix"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    ref: "togglebutton",
    staticClass: "checked",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        _vm.togglebuttonSelect()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('span', {
    staticClass: "selcteditem"
  }, [_vm._v(_vm._s(_vm.currenttoggle))])]), _vm._v(" "), _c('div', {
    staticClass: "salesblock clearfix"
  }, [_c('div', {
    staticClass: "highlitboxes basesales totalspent"
  }, [_vm._v("Total Spend\n      "), _vm._m(0), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currencySymbol) + _vm._s(_vm.TotalSpent))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareTotalSpent) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareTotalSpentArrow === 1 ? 'fa-caret-up green' : _vm.CompareTotalSpentArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes"
  }, [_vm._v("Non Media " + _vm._s(_vm.kpi) + "\n      "), _vm._m(1), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.BaseSales))])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes medadsale togglerBoxes active"
  }, [_vm._v("Paid Media " + _vm._s(_vm.Tkpi) + "\n      "), _vm._m(2), _vm._v(" "), _c('b', {
    staticClass: "MediaDrivenSales"
  }, [_vm._v(_vm._s(_vm.MediaDrivenSales))]), _vm._v(" "), _c('b', {
    staticClass: "MediaDrivenROI"
  }, [_vm._v(_vm._s(_vm.MediaDrivenROI))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareMediaDrivenSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareMediaDrivenSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareMediaDrivenSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes ecosyssales togglerBoxes active"
  }, [_vm._v("O/E Ecosystem " + _vm._s(_vm.Tkpi) + "\n      "), _vm._m(3), _vm._v(" "), _c('b', {
    staticClass: "EcosystemSales"
  }, [_vm._v(_vm._s(_vm.EcosystemSales))]), _vm._v(" "), _c('b', {
    staticClass: "EcosystemROI"
  }, [_vm._v(_vm._s(_vm.EcosystemROI))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareEcosystemSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareEcosystemSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareEcosystemSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])]), _vm._v(" "), _c('div', {
    staticClass: "highlitboxes tsales"
  }, [_vm._v("Total " + _vm._s(_vm.kpi) + "\n      "), _vm._m(4), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.TotalSales))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.CompareTotalSales) + "%\n        "), _c('i', {
    staticClass: "fa",
    class: _vm.CompareTotalSalesArrow === 1 ? 'fa-caret-up green' : _vm.CompareTotalSalesArrow === 0 ? ' ' : 'fa-caret-down red'
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "chartarea",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    ref: "tooltip",
    staticClass: "tooltip2"
  }, [_vm._v(_vm._s(_vm.tooltipcontent))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mynetwork"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "report-anualspent"
  }, [_vm._v("Annual Spend")]), _vm._v(" "), _c('div', {
    staticClass: "report-max-uplift"
  }, [_vm._v("Max Uplift: " + _vm._s(_vm.currentnest_name))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix leftside"
  }, [_c('div', {
    staticClass: "slidertop clearfix"
  }, _vm._l((_vm.sliderinputval), function(sliderinputval, index) {
    return _c('div', _vm._b({
      key: sliderinputval.name,
      staticClass: "slider-wrapper"
    }, 'div', sliderinputval, false), [_c('label', [_vm._v(" " + _vm._s(sliderinputval.name))]), _vm._v(" "), _c('vue-slider', _vm._b({
      ref: 'slider' + index,
      refInFor: true,
      attrs: {
        "max": sliderinputval.max_value,
        "label": sliderinputval.name
      },
      on: {
        "callback": function($event) {
          _vm.checkslider(sliderinputval, $event)
        }
      },
      scopedSlots: _vm._u([{
        key: "tooltip",
        fn: function(ref) {
          var spend = ref.spend;

          return _c('div', {
            staticClass: "slider-tooltip"
          })
        }
      }]),
      model: {
        value: (sliderinputval.spend),
        callback: function($$v) {
          _vm.$set(sliderinputval, "spend", $$v)
        },
        expression: "sliderinputval.spend"
      }
    }, 'vue-slider', _vm.slideroptions, false)), _vm._v(" "), _c('div', {
      staticClass: "slider-text"
    }, [_c('input', {
      attrs: {
        "pattern": "^[\\d,]+$",
        "type": "text"
      },
      domProps: {
        "value": index = sliderinputval.spend.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      },
      on: {
        "input": function($event) {
          _vm.updateSlider(sliderinputval, $event)
        }
      }
    })])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "optimiseWidgetWrapper"
  }, [_c('div', {
    staticClass: "inputOptimizeNamr view"
  }, [_c('a', {
    staticClass: "verclosebutton",
    on: {
      "click": function($event) {
        _vm.verclosebutton()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.versionName),
      expression: "versionName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "optimname",
      "placeholder": "Optimisation Version Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.versionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.versionName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "reportbutton optimiseBtnGO",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.NewOptimisebtntrigger()
      }
    }
  }, [_vm._v("GO")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down optiarrow",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton optimiseBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.NewOptimisebtnClick()
      }
    }
  }, [_vm._v("Optimise")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix excelwrapper reportpageexcelwrapper"
  }, [_c('HotTable', {
    staticClass: "handsontable handsontableReport",
    attrs: {
      "root": _vm.root,
      "settings": _vm.hotSettings,
      "observeChanges": "true",
      "onAfterChangesObserved": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "reportbuttonwrapper clearfix"
  }, [_c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.updateBtnDisable
    },
    on: {
      "click": function($event) {
        _vm.UpdatebtnClick('update')
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savebuttonclick
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "reportbutton resetreportBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetbtnClick()
      }
    }
  }, [_vm._v("Reset")])]), _vm._v(" "), _c('div', {
    staticClass: "helpertable"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("Model Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.modelname))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Market")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.country))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Category")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.category))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelVesrionSelect),
      expression: "modelVesrionSelect"
    }],
    ref: "versionsCombo",
    staticClass: "form-control",
    attrs: {
      "id": "modelVesrionSelect"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modelVesrionSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.modelVesrionSelectChanged()
      }]
    }
  }, _vm._l((_vm.versions), function(versions, index) {
    return (versions.version_status === 'completed' ? 'disable' : '') ? _c('option', {
      key: versions.version_id,
      attrs: {
        "disabled": false
      },
      domProps: {
        "selected": index === 0 ? true : false,
        "value": index
      }
    }, [_vm._v(_vm._s(versions.text))]) : _vm._e()
  }))])])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "heading",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          Version\n        ")])])
}]}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "has-sub"
  }, [_c('ul', [_c('li', {
    staticClass: "active pageLink",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home.svg",
      "alt": "Home"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "pageLink",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/report"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Report")])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    staticStyle: {
      "display": "none"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ })
],[156]);


// WEBPACK FOOTER //
// static/js/app.cb172d7b6890f4823f7b.js